var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 66.12 85.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-6{fill:gray;}.cls-2{opacity:0.1;}.cls-3{fill:#666;}.cls-4{fill:#999;}.cls-5{fill:#4d4d4d;}.cls-6{stroke:#1a1a1a;stroke-miterlimit:10;}.cls-7{opacity:0.31;}.cls-8{opacity:0.5;}.cls-9{fill:#333;}.cls-10{opacity:0.13;}.cls-11{opacity:0.25;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "COIN") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_7",
    "data-name": "Layer 7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.31,1.79a11.49,11.49,0,0,0-.51,3.87l3.14-.42c-.31-1.19-.62-2.36-.94-3.54-.58-2.17-3.54-1.19-3.26.9A113.39,113.39,0,0,1,35,15.74c.06,3.2-.37,6.49.55,9.62C37,30.5,41.68,33.54,46,36.15a2.23,2.23,0,0,0,3.32-1.91c.52-7.28,1.2-14.54,1.74-21.82C51.32,8.83,53,2.65,48.7.68,46-.56,39.64-.09,37.41,2c-2.75,2.5-.53,7,.73,9.76.76,1.67,3.62,1.24,4-.52.24-1.28.49-2.55.75-3.82l-4.39-.6a42,42,0,0,0,.85,12.61c.48,2.24,3.7,2,4.31,0a8.91,8.91,0,0,0,.16-4.75l-4.31,1.19A73.23,73.23,0,0,1,41,24.39c.31,2.73,4.47,2.89,4.38,0l-.24-7.64-4.23.57a55,55,0,0,1,1.4,7.08c.26,2.07,3.69,3.1,4.08.55a107.25,107.25,0,0,0,1.28-13.63c.08-2.63-3.92-2.6-4.06,0q-.33,6.23-.65,12.44c-.14,2.59,3.78,2.54,4,0,.42-4.92.81-9.83,1.27-14.75.22-2.27-3.53-2.77-4-.54A80.22,80.22,0,0,0,42.77,19.8c-.15,2.3,3.62,2.85,4.06.55A43.09,43.09,0,0,0,47.36,7a2.08,2.08,0,0,0-4.15,0q-.42,5.37-.82,10.76c-.19,2.65,3.93,2.63,4.13,0a48.44,48.44,0,0,0-.81-13.33c-.46-2.31-4-1.72-4,.54L41.6,15.15l4.08-.56q-.69-4.5-1.37-9c-.39-2.51-3.91-1.61-4.13.55q-.8,8.08-.89,16.19h4.25c-.16-2.93-.47-5.84-.88-8.75-.34-2.4-4.28-1.81-4.2.57a81.49,81.49,0,0,0,1.15,11.46L43.54,24l-2.72-5.14c-1.13-2.12-4.66-.67-3.91,1.64l2.94,9,4.07-1.12-2.1-5.45L38,24.53a30.66,30.66,0,0,0,5.48,6.74A2.15,2.15,0,0,0,47,29.2l-.55-2.57-4.18.56,1,2.6c.76,2,4.36,2,4.12-.56a24.6,24.6,0,0,1,.18-6.74H43.69c.15,1,.29,1.91.43,2.87.36,2.37,3.76,1.55,3.94-.53.59-6.84.87-13.67.83-20.53,0-2.82-4.44-2.82-4.37,0q.24,10.27-.47,20.53L48,24.29c-.14-.95-.29-1.91-.43-2.86-.3-1.94-3.51-1.88-3.86,0a29.57,29.57,0,0,0-.51,7.8l4.12-.56-.9-2.61c-.74-2.12-4.42-2-4.19.57a13.46,13.46,0,0,0,.71,3.71l3.55-2.07a25.38,25.38,0,0,1-4.86-5.86c-1.18-2-4.71-.68-3.84,1.62l2.08,5.45C40.8,32,44.77,31,43.92,28.36l-2.89-9L37.13,21l2.7,5.16c1.21,2.3,4.3.59,3.93-1.66a79.26,79.26,0,0,1-1-10.32l-4.21.57c.37,2.54.61,5.06.76,7.61.16,2.72,4.23,2.76,4.25,0,.05-5.41.32-10.8.84-16.19l-4.12.56,1.41,9c.37,2.35,4.07,1.72,4.08-.55L45.78,5l-4,.55a43,43,0,0,1,.63,12.24h4.13Q47,12.42,47.36,7H43.21a39.4,39.4,0,0,1-.37,12.21l4.06.55A90.79,90.79,0,0,1,48.17,9.55l-4-.54c-.37,4.92-.8,9.84-1.21,14.75h4q.35-6.23.71-12.44H43.62A92.28,92.28,0,0,1,42.4,23.85l4.07.55a57.39,57.39,0,0,0-1.4-8.22,2.16,2.16,0,0,0-4.22.57L41,24.39h4.38a77,77,0,0,0-1.6-9.76c-.66-2.81-4.87-1.61-4.31,1.19l-.16,2.37h4.31a37.74,37.74,0,0,1-.69-11.42c.21-2.48-4-3.08-4.39-.59-.2,1.29-.41,2.57-.63,3.85l4-.52c-1.1-2.42-1.49-3.8,1-4.72.87-.33,3.52-.43,4.18.51.83,1.17-.57,7.53-.69,9.11-.51,6.61-.89,13.22-1.42,19.83l3.32-1.9c-2.53-1.46-5.22-2.9-7-5.24-2.19-2.82-2.08-6-2.39-9.42-.48-5.34-1-10.67-1.79-16l-3.26.9c.37,1.16.74,2.32,1.12,3.48a1.6,1.6,0,0,0,3.08-.84L37.7,2.11a1.22,1.22,0,0,0-2.39-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.85,4.76l.25-.86-3.52-.47c-1.29,13.72-1.52,27.84-1.48,41.63a2.08,2.08,0,0,0,1,1.82c2.85,1.25,5.52.33,6.74-2.71,2.16-5.39,1.9-12.83,2.33-18.55.25-3.28.44-6.57.53-9.86.08-3.13.74-7.27-.22-10.29-1.26-4-5.43-4.71-9-4.83-2.92-.1-2.82,4.2,0,4.47s5.59.58,8.39.93l-1.1-4c-7.21,5.18-3.27,13.48-4,20.82-.28,2.87,4.15,2.82,4.46,0,.56-5.11,1-10.24,1.57-15.36H60.56c.38,13.47.37,27-1.41,40.41l4.67-.63a157.59,157.59,0,0,1-1.69-28.63l-4.52.62c1.4,9.75-.47,19.36-1.48,29l3.65-2.09-3.42-1.72c-2.77-1.38-5.19,2.66-2.45,4.19,4.88,2.71,4.31,8.37,4,13.17a2.43,2.43,0,0,0,2.4,2.4c2.58-.09,4.06-1.54,4.38-4.12.67-5.39-.07-11.38-.11-16.82H59.74c.42,7.84.77,15.68,1.13,23.52.14,3,4.89,3.06,4.75,0-.36-7.84-.75-15.68-1.05-23.52-.12-3.1-4.89-3.12-4.83,0,0,1.46.12,16.14.56,16.14l2.4,2.4c.56-6.67,0-13.66-6.34-17.36l-2.45,4.19,3.42,1.72A2.47,2.47,0,0,0,61,48.27c1.06-9.85,2.3-19.76,1.14-29.66-.34-2.88-4.47-3-4.6,0a173.54,173.54,0,0,0,1.62,29.26c.3,2.37,4.22,3.55,4.67.63,2.12-13.67,1.52-27.27,1-41-.1-2.8-4-2.69-4.28,0C60,12.59,59.35,17.7,58.81,22.82h4.46c.45-5-3.15-13.52,1.71-17.08a2.19,2.19,0,0,0-1.09-4c-2.61-.29-5.21-.61-7.8-1L55.5,5.11c5.36.18,4.87,4.78,4.82,8.67,0,3.29-.15,6.59-.32,9.87-.1,1.72-1.87,20-2.73,19.59l1,1.82c.81-13.76,1.38-27.86.85-41.63C59.09,1.52,56,.87,55.65,3l-.15.89C55.15,6,58.2,7,58.85,4.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64.19,66.57a10.14,10.14,0,0,0-1.07,4.22,8.33,8.33,0,0,0,.43,4.35.9.9,0,0,0,1.54,0,8,8,0,0,0,.85-4,10.39,10.39,0,0,0-.55-4.36c-.18-.49-.93-.71-1.2-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.46.81a4.63,4.63,0,0,0-5.06,1,.27.27,0,0,0,.05.42,4.68,4.68,0,0,0,5.07-1,.28.28,0,0,0-.06-.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64.47,5.17c-1.13.71-.8,2.45-.89,3.62-.13,1.86-.57,3.91-.06,5.73a.61.61,0,0,0,1.11.15c1.26-1.93,1.1-4.73,1-6.93,0-.19-.2-3.17-1.14-2.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52,.58c-1.27,1.64-1.44,3.62-1.65,5.64a20.58,20.58,0,0,0,.33,7.34c.21.8,1.61.91,1.75,0,.31-2.12.33-4.26.49-6.4S53.67,3,53.15.89A.71.71,0,0,0,52,.58Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.25,78.78c10.82-3.59,12.17-16.85,9.26-26.36S45.73,32.17,35.22,30.56a1.48,1.48,0,0,0-1.13,2.69c6.48,5,12.8,9.4,16.4,17,4,8.41,5.21,20.7-4.47,25.57-1.61.81-.49,3.5,1.23,2.93Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M33.16,2.08c.61,11.12-1.06,22.53.56,33.56C34,37.7,37,37,37.16,35.18c.75-11-1.83-22.11-2.1-33.1,0-1.23-2-1.23-1.9,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M36.43,31.71c4.85,6.42,12.3,10.17,15.35,18.07,1.58,4.08,2.87,9.62.69,13.57a31.7,31.7,0,0,1-8.22,10.06c-1.44,1.08-1.77,4.19.59,4.51,14,1.89,15-18.29,12-27.45l-4.36,1.84a14.41,14.41,0,0,1-1.73,16.53c-1.49,1.76-.13,4.8,2.36,4.07l.45-.13c3-.87,1.71-5.6-1.3-4.7l-.44.14,2.37,4.07A19.71,19.71,0,0,0,56.64,49.9c-1.22-2.4-5.17-.73-4.36,1.84,1.42,4.48,3.55,23.66-6.13,21.43l.59,4.5a33.91,33.91,0,0,0,9.83-11c2.59-4.29,2.61-8.28,1.49-13.07-2.42-10.45-11-18.22-19.79-23.73-1.08-.67-2.67.74-1.84,1.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M41.9,77.45c6.67,4,16.9,1.25,23.43-1.87L64,73.3c-2.33,1.78-6,1.29-8.89,1.85-3.86.77-7.09,1.8-11,.57-1.9-.6-2.57,2.22-.8,2.92,4,1.58,7.95.84,12,0,3.61-.73,7.57-.53,10.3-3.3a1.33,1.33,0,0,0-1.28-2.2,49,49,0,0,1-12.12,2.24c-3.37.17-6.72-.41-10,.18a1,1,0,0,0-.24,1.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M57.87,61c-.63,4.48,1.59,8.85,3.52,12.76l3.45-2c-2.33-3-6.26-2.55-7.64,1.06-.81,2.11,2.65,3.56,3.66,1.54l.52-1a2,2,0,0,0-3.14-2.43L55.61,73l2.83,2.83,1.66-1.34c1.72-1.39-.22-3.6-1.93-3.32a12.32,12.32,0,0,0-3.9,1.36L57,75.22c1.67-2.68,6.72-7.76,2.53-10.4a1.81,1.81,0,0,0-2.46,2.46c.79,1.27-2.38,4.84-3.21,5.51-1.82,1.48.5,4.19,2.42,3.15a8.46,8.46,0,0,1,2.94-1L57.3,71.63,55.61,73c-2,1.58.83,4.41,2.83,2.83l2.63-2.09-3.14-2.42-.53,1,3.66,1.54.64.3c1.44,1.86,4.14-.51,3.14-2.42A52.83,52.83,0,0,1,60.67,61c-.35-1.28-2.59-1.49-2.8,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M58,59.93V60a.11.11,0,0,0,.21,0l0-.07c0-.2-.29-.2-.24,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M55.92,48.09a29.8,29.8,0,0,0,0,6.54c.1,2.18-.15,4.55.76,6.56.41.92,1.7.53,2-.25.83-2.4.17-5.62,0-8.13-.13-2.27-.2-3.68-2.13-5a.44.44,0,0,0-.64.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M46.22,36c.18.88,1,1.4,1.57,2.09.94,1.21,1.73,2.57,2.56,3.86,1.24,1.94,2.44,5.34,4.55,6.37a1,1,0,0,0,1.48-.85c.15-2.42-2.51-5.12-3.91-6.95s-3-4.36-5.28-5.07a.7.7,0,0,0-.71.19c-.09.08-.29.21-.26.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M37.44,29.81l-.08-.46-1,.78A34,34,0,0,1,44.77,36c.89.9,2.3-.51,1.39-1.4a21.31,21.31,0,0,0-9.28-5.68c-1.13-.29-1.09,1.64,0,1.33l.41-.12a.22.22,0,0,0,.15-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M35.49,18.39A18.77,18.77,0,0,0,36,22c.16,1,1.8.56,1.51-.42a19.65,19.65,0,0,0-1.17-3.36.43.43,0,0,0-.8.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M34.41,6.52l0,0a.69.69,0,0,0-.5.66,8.64,8.64,0,0,0,.55,3.15c.4,1.07,2.14.59,1.72-.47A19.06,19.06,0,0,1,35.23,7a.69.69,0,0,0-.67-.5c.15,0-.08,0-.15,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M37.46,22.53a1.28,1.28,0,0,0-.36-.16.7.7,0,0,0-.85.48l-.19.51c-.34.93,1.31,1.35,1.45.4l.07-.54-.31.41c.33-.23.65-.8.19-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M48.3,2c-.34,8.13-.12,16.32.08,24.45C48.56,34,48.19,42,49.63,49.4c.38,1.94,3.11,1.31,3.25-.44.6-7.69-.53-15.74-.71-23.46S52.13,9.85,52,2A1.83,1.83,0,0,0,48.3,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M54.71.83C53.63.77,52.56.69,51.49.58c-1.35-.11-1.37,2.06,0,2.11l1.44.06L51.84,1.66c.2,6.38.35,12.76.37,19.15a1.37,1.37,0,0,0,2.74,0,73.08,73.08,0,0,0-1-11.91c-.25-1.58-2.86-1.2-2.79.38.34,7.15.39,14.31.05,21.46-.28,5.88-1.07,11.67.49,17.44a1.5,1.5,0,0,0,2.71.35c1.44-2.16,1.35-4.2,1.12-6.71A119.61,119.61,0,0,1,55,29.12c.18-8.83.4-17.65.53-26.48,0-2.57-4-2.57-4,0-.11,7.52-.23,15-.23,22.56,0,3.59,0,7.19.21,10.78.22,3,2,8.43.29,11.05l2.71.36C52.89,41.33,54,35,54.18,28.79c.23-6.51.13-13-.19-19.51l-2.79.38a86.67,86.67,0,0,1,1,11.15H55c-.4-6.38-.69-12.76-.92-19.15a1.12,1.12,0,0,0-1.1-1.1l-1.44,0V2.69c1.07-.1,2.14-.18,3.22-.24a.81.81,0,0,0,0-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.75,12.12c3.74.91,7.65.65,11.48.64a63.27,63.27,0,0,0,11.51-.66.55.55,0,0,0,0-1.06,63.2,63.2,0,0,0-11.51-.49c-3.83,0-7.75-.16-11.48.81a.4.4,0,0,0,0,.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.27,36.41c1.91.62,4.09.34,6.06.17,1.63-.14,3.41-.18,4.67-1.29a.58.58,0,0,0-.25-1c-1.6-.63-3.53,0-5.2.1a27.41,27.41,0,0,0-5.28.53.76.76,0,0,0,0,1.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.16,49.45a28.23,28.23,0,0,0,4.41.14c.7,0,2-.15,1.88-1.15s-1.62-.91-2.32-.88A30.52,30.52,0,0,0,55,48c-.9.15-.57,1.4.2,1.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.5,61.7c2.25.17,5,.34,7.08-.82a.42.42,0,0,0-.1-.75c-2.21-.79-4.94-.13-7.13.44a.58.58,0,0,0,.15,1.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.52,70.08,62,69.59a6.27,6.27,0,0,0,2.93-.81.35.35,0,0,0-.09-.63,6,6,0,0,0-2.91.25c-1.21.26-2.4.54-3.6.81-.58.13-.32,1,.24.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64.67,68.62c-.85.66-.47,2-.54,3-.09,1.35-.31,2.66-.27,4a.49.49,0,0,0,.9.25,7,7,0,0,0,1.29-4c0-1,.29-2.78-.84-3.29a.49.49,0,0,0-.54.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.26,23.84a14.26,14.26,0,0,0,5.78.58c1.68-.08,3.66-.13,5.1-1.05a.49.49,0,0,0-.24-.9c-1.72-.2-3.51.41-5.24.5s-3.53-.11-5.29,0a.42.42,0,0,0-.11.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.06,49a25.16,25.16,0,0,0,5.39-1,.17.17,0,0,0,0-.34,24.71,24.71,0,0,0-5.39,1c-.17,0-.14.33,0,.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.75,69.65a4.68,4.68,0,0,0-1.14-.75l-.4.94c3.32.7,8.38.86,11-1.76a.34.34,0,0,0-.24-.58,23.68,23.68,0,0,0-4.7.92,27,27,0,0,1-5.89.4c-.57,0-.72.93-.14,1a7.18,7.18,0,0,0,1.45.13.17.17,0,0,0,.09-.32Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.45,80.25C57,75.41,58.8,63.06,56.94,54.31,54.68,43.6,46.46,34.82,36.87,30a2.34,2.34,0,0,0-3.1.81l-.25.39c-1,1.47.66,3.75,2.38,3.11-.25.09,3.36,2.62,3.77,2.91A38.68,38.68,0,0,1,45,41.76,31.19,31.19,0,0,1,52.58,54c2.92,9.35-.73,16.81-6.22,24.12-1,1.29.86,2.8,2.09,2.1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.35,74l1.72.69A1.54,1.54,0,0,0,60.35,74c-2.4.43-4.74,1.11-7.15,1.5-2.17.35-4.54.16-6.46,1.27a1.53,1.53,0,0,0,0,2.62c2.21,1,4.66.48,7,0a24.74,24.74,0,0,0,7.78-2.66c1.58-.89.46-3.07-1.17-2.77Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.26,2.93c-.25.51-.61.74-.71,1.35a6.14,6.14,0,0,0,.23,2.17c.3,1.28.89,3,2.18,3.57a.6.6,0,0,0,.89-.51c0-1.24-.85-2.39-1.21-3.57-.18-.61-.25-1.28-.47-1.88-.17-.44-.54-.69-.71-1.1,0-.08-.15-.13-.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.94,12.3c-1.2,4-.12,7.77,1.64,11.41l1.62-1.25-1-1.12a1.06,1.06,0,0,0-1.75.47c-.45,3.19-1,6.48-.56,9.69.11.83,1.47.79,1.62,0,.59-3,.55-6.11,1-9.14l-1.75.47,1,1.09c.83.89,2.15-.24,1.62-1.25-1.7-3.31-2.18-6.78-2.9-10.37a.27.27,0,0,0-.52,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M62.84,3c-.6,5.11,0,10.45-.05,15.6,0,4.56-.84,9.41.16,13.87a.87.87,0,0,0,1.66,0c1.56-4.59,1-10,1-14.85s.15-10.08-1-14.86C64.4,1.66,63,2,62.84,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M58,2a51.15,51.15,0,0,0,.14,8,.16.16,0,0,0,.32,0,52.36,52.36,0,0,0-.24-8A.11.11,0,0,0,58,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M59.37,17.9a40.47,40.47,0,0,0,0,5.93.2.2,0,0,0,.39,0,41.92,41.92,0,0,0,0-5.93.18.18,0,0,0-.36,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M43.74,21.15a12.31,12.31,0,0,0-.15-3.09c0-.14-.23-.1-.24,0a12.31,12.31,0,0,0,.2,3.09.1.1,0,0,0,.19,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M60.86,34c0-1.35,0-2.68,0-4a.11.11,0,0,0-.21,0c-.11,1.34-.08,2.67-.06,4a.16.16,0,0,0,.32,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M60.17,43.29a4.68,4.68,0,0,0-.08,1.94,14.34,14.34,0,0,0,.22,2c0,.2.31.13.33,0a17.94,17.94,0,0,0,0-2.2,3.81,3.81,0,0,0-.26-1.68c0-.11-.19-.06-.22,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M57.64,37.23a0,0,0,0,0,0,0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M57.36,35.68c.15,3.81.25,7.67.68,11.47,0,.13.22.14.22,0,0-3.83-.42-7.67-.74-11.47,0-.11-.17-.11-.16,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M41.7,23.06a86.87,86.87,0,0,0,.21,18.38c0,.12.22.09.22,0-.1-6.12-.42-12.21-.32-18.34,0-.07-.1-.07-.11,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M38.56,11.79a45.7,45.7,0,0,0,.77,11.13c0,.22.41.17.39-.05-.28-3.68-.49-7.42-.9-11.08a.13.13,0,0,0-.26,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M36.63,11.11a56.09,56.09,0,0,0,28.25.33c.05,0,0-.1,0-.1A134.54,134.54,0,0,1,36.64,11s0,.06,0,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M34.43,23c9,2,18.88,2.48,27.91.43a.26.26,0,0,0-.07-.51c-9.43.38-18.35.54-27.76-.55-.36-.05-.43.55-.08.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M47.55,36.34c1.75,1.06,4.15.65,6.13.54a25.32,25.32,0,0,0,7.13-1.21.37.37,0,0,0-.1-.72c-2.52,0-5,.47-7.54.62-1.87.11-3.92-.27-5.62.59a.11.11,0,0,0,0,.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M55.74,61l-.36-.07a.2.2,0,1,0-.05.4A18.91,18.91,0,0,0,62.46,60a.2.2,0,0,0-.1-.38c-2.34.43-4.77.79-7.08,1.34l.15.37.33-.17a.07.07,0,0,0,0-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M55.86,70A19.65,19.65,0,0,0,66,67.86c.13-.07,0-.26-.1-.23-1.69.38-3.33.9-5,1.26s-3.4.53-5.06,1a.07.07,0,0,0,0,.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M33.22,2.74C38.58,2,44,1.57,49.31.86a.29.29,0,0,0,0-.58,50.52,50.52,0,0,0-16.1,2.34c-.07,0-.06.13,0,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M55.4,1.53a45.31,45.31,0,0,0,.05,7.55.27.27,0,0,0,.54,0,45.31,45.31,0,0,0,0-7.55.32.32,0,0,0-.64,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M63.84,31.59a75.9,75.9,0,0,0,.69,19.85c0,.32.52.22.54-.07a76,76,0,0,0-1-19.81c0-.13-.2-.09-.21,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M53.25,48.47c2.9,1.6,8,.23,10.73-1.12.29-.14.08-.57-.21-.5A42,42,0,0,1,57.89,48c-1.53.13-3.15-.14-4.62.31a.11.11,0,0,0,0,.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M52.16,37.6a21.65,21.65,0,0,0,10.58-2.19c.33-.15.14-.62-.17-.64-.72,0-1.43-.07-2.15-.05-.3,0-.4.5-.07.55.74.1,1.47.15,2.22.19l-.17-.64a28.38,28.38,0,0,1-10.24,2.51.14.14,0,0,0,0,.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33,2.06c-.14,24.86-.22,49.77.19,74.62a.11.11,0,1,0,.22,0c.29-24.85.08-49.76-.2-74.62a.11.11,0,0,0-.21,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.56.79c-.93,24.18-.78,48.51.26,72.68a.15.15,0,1,0,.3,0C65.43,49.23,65.38,25,65.79.79a.12.12,0,0,0-.23,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.88,77.79a42.94,42.94,0,0,0,31.16-2c.17-.08,0-.32-.14-.24a44.48,44.48,0,0,1-31,2,.08.08,0,0,0,0,.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.18.81l-3.42.86c-.1,0,0,.17.05.15A88.85,88.85,0,0,1,66,2.27c.1,0,.14-.13,0-.15A74,74,0,0,0,48.5.07a77.69,77.69,0,0,0-9.28.55C38,.76,32.05,2,36.18.82c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.05,10.67a128.6,128.6,0,0,0,31,0s0-.07,0-.07a239.31,239.31,0,0,1-31,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.78,68.86A63.42,63.42,0,0,0,64.09,67.8c.08,0,0-.15,0-.13a86.33,86.33,0,0,1-28.27,1.14,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,22.27a74.2,74.2,0,0,0,27.75-.11c.1,0,0-.16,0-.14A95.87,95.87,0,0,1,36,22.19s-.08.07,0,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,34.32a70.23,70.23,0,0,0,27.18.1c.06,0,0-.1,0-.09A83.16,83.16,0,0,1,36,34.21c-.07,0-.1.09,0,.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.32,47a52.7,52.7,0,0,0,26.43-.09.07.07,0,0,0,0-.14,61.19,61.19,0,0,1-26.36.13c-.07,0-.09.09,0,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.26,60.09,40,60c-.07,0-.1.1,0,.11a65,65,0,0,0,23.19-.74c.11,0,.06-.19,0-.17a86.23,86.23,0,0,1-12.41,1.33c-3.48.08-7-.55-10.43-.43,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 27.78,
    cy: 57.89,
    r: 27.28
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.56,45.83l.09-.1s0,0,0,0l-.1.09a0,0,0,0,0,0,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M43.39,58.29a6.61,6.61,0,0,0,2.85-1.42l-.37-.37A16.31,16.31,0,0,1,44,58.18c-.21.15-.1.55.19.45,1.21-.43,2.74-1.45,3-2.81,0-.15-.17-.3-.28-.16-.39.45-.65,1-1.08,1.4a4.65,4.65,0,0,1-1.79,1.09l.2.45a17.06,17.06,0,0,0,2-1.73c.24-.25-.12-.58-.37-.37a8.21,8.21,0,0,1-2.59,1.39.21.21,0,0,0,.11.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M44.55,57.77c-2.9.83-4.29-2.86-7.11-2.45-2.25.33-3.55,2.81-5.71,3.42a.26.26,0,0,0,.14.51,5.67,5.67,0,0,0,2.08-1c.68-.51,1.53-1.58,2.28-1.87a5,5,0,0,1,4.56.89c1.22.86,2.47,1.68,3.84.69.09-.06,0-.22-.08-.18Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M33.25,61.51c.68,1.31,2,3.52,3.41,4.21.62.32,1,.13,1.61,0,1.07-.23.21-.59,2-.57.54,0,1.12.19,1.67.22a.16.16,0,0,0,.08-.29,4.07,4.07,0,0,0-3-.35,4.42,4.42,0,0,1-2.74-.07,4.35,4.35,0,0,1-.83-.93c-.68-.78-1.29-1.62-2-2.39-.12-.12-.3,0-.23.18Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M36.49,62.88c.63.84,2.23,1.71,2.72.24a.26.26,0,0,0-.19-.33,2.28,2.28,0,0,0-1.75.24.27.27,0,0,0,0,.46c1.13.59,2.21-.26,2.65-1.32a2.82,2.82,0,0,0-1-3.44c-.2-.12-.38.15-.24.31a2.91,2.91,0,0,1,.9,2.23c-.09.92-.91,2.37-2.06,1.76v.46a1.7,1.7,0,0,1,1.34-.18L38.69,63c-.37,1.09-1.56,0-1.91-.32-.14-.12-.42,0-.29.22Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M41.65,61.21c.45-.22.69-.82.94-1.22a6.92,6.92,0,0,0,.87-1.54.14.14,0,0,0-.23-.14,6.41,6.41,0,0,0-1,1.48c-.25.41-.67.9-.65,1.39,0,0,0,0,0,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M44.4,62.51c.69,0,1.29-.95,1.61-1.47a4.82,4.82,0,0,0,.79-2.57c0-.23-.36-.29-.41-.06a7.24,7.24,0,0,1-.79,2.39,5.57,5.57,0,0,1-.79,1c-.23.22-.39.32-.46.63a.06.06,0,0,0,0,.06Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M46.73,58.69a3.12,3.12,0,0,0,2.21-1.51c.81-1.24.47-2.72,1.23-4,.18-.29-.26-.53-.45-.27-.7,1-.48,1.72-.68,2.83-.25,1.41-1.24,2.07-2.36,2.75-.07,0,0,.18,0,.17Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M49.07,53.38c-.47-.56-1.61.59-1,1.07a.18.18,0,0,0,.27,0c.14-.19.1-.41.28-.59s.34-.16.48-.28a.11.11,0,0,0,0-.16Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M46.31,52.55c-.31.59.68.94,1.11.92a.3.3,0,0,0,.21-.5c-.25-.32-.9-.94-1.34-.61s0,1.24.15,1.55c.07.12.29.12.31,0a2.13,2.13,0,0,0-.06-.87l0-.23a.37.37,0,0,0,.25.28,2.46,2.46,0,0,1,.31.33l.2-.5c-.43,0-.61-.35-1-.4a.14.14,0,0,0-.12.07Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M45.08,49.16A2.67,2.67,0,0,0,43.82,49a7,7,0,0,0-1.21,0c-.53.11-.89.61-.52,1.08.14.18.45,0,.38-.22-.18-.49,1.33-.43,1.55-.45a2.35,2.35,0,0,0,1.06-.18.08.08,0,0,0,0-.13Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M49.6,52.39c-1.44-1.74-3.53-3.16-4.38-5.26-.5-1.25-2.93-3.53-.89-4.8a.19.19,0,0,0,0-.32c-.8-.34-1.27-.24-.47-.64.16-.09.09-.31,0-.37-1.16-.44-2.32,0-.59-1.23a.19.19,0,0,0,0-.35,9.5,9.5,0,0,0-3.71-.33c-.23,0-.24.37,0,.36.45,0,2.86-.26,3,.35,0-.12-.94,1-.92,1s0,.35.14.33c1.31-.11,1.85,0,.85.48-.19.1-.07.35.1.37,1.77.2.26.95.28,2,0,1.36,2.24,2.33,1.76,3.67a.18.18,0,0,0,0,.18c1.57,1.57,3.07,3.25,4.75,4.71a.07.07,0,0,0,.1-.1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M36.82,46.18a3,3,0,0,0,.79-.13,5.31,5.31,0,0,1,1-.08.21.21,0,0,0,0-.42,4.37,4.37,0,0,0-1.85.33.21.21,0,0,0-.09.34,3,3,0,0,0,1.69,1c.4,0,1-.36.63-.79-.06-.09-.24-.11-.27,0-.16.89-1.52-.25-1.76-.49l-.09.34a4.32,4.32,0,0,1,1.74-.3v-.42a2.86,2.86,0,0,0-1.91.45.1.1,0,0,0,.07.18Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M39,44.37c-.43.62.87,1.68,1.33,1.94.07,0,.63.24.64.27s-.55.19-.66.23a1.81,1.81,0,0,0-1.06.8c-.14.21.17.44.34.26a2.06,2.06,0,0,1,.93-.63,2,2,0,0,0,.73-.2.51.51,0,0,0,.14-.73c-.12-.14-.31-.14-.48-.19a2.85,2.85,0,0,1-.93-.56,3,3,0,0,1-.62-.84c-.12-.21-.11-.28-.32-.36Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M42.09,53.23c-.84-4.63-9.17-5.52-12.76-4.79-.11,0-.09.2,0,.2,4.53,0,10,.37,12.67,4.61a0,0,0,1,0,.06,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M27.56,50.37a75.71,75.71,0,0,1,7.78.93c2.25.5,4.33,1.36,6.52,2a.08.08,0,0,0,.06-.14,25.4,25.4,0,0,0-14.36-2.92,0,0,0,1,0,0,.09Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M43.58,54.61c-2.59-2-5.94-2.34-9.1-2.5-2.39-.12-5.21-.44-7.11,1.25-.09.07,0,.19.11.15,4.71-2.41,11.49-.79,16,1.24a.08.08,0,1,0,.08-.14Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M29.82,55.35a27,27,0,0,1,13.31.58.15.15,0,0,0,.08-.29,23.15,23.15,0,0,0-14.51-.28.12.12,0,0,0,0,.23,2,2,0,0,0,1.11-.2s0,0,0,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M42.58,56.2c-3.79-.79-9.75-1-13.13,1.25a.12.12,0,0,0,.12.21c4.13-1.77,8.62-1.49,13-1.24a.11.11,0,0,0,0-.22Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M31,59.93c2-.39,4-1.06,6.06-1.45s4.12-.51,6.17-.8c.14,0,.1-.23,0-.24a27.73,27.73,0,0,0-12.23,2.42s0,.08,0,.07Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M40,56.57l.37.19c.08,0,.16-.06.1-.12-1-1.06-2.53-2.1-4-1.51a4,4,0,0,0-1.5,1.44A16.28,16.28,0,0,1,31.09,60a.14.14,0,0,0,.14.25,10.07,10.07,0,0,0,3.48-2.7c.64-.75,1-1.42,1.95-1.8a2.51,2.51,0,0,1,2.42.26c.27.14.61.53.9.58,0,0,0,0,0,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M38.16,67.58a4.1,4.1,0,0,1,2.16-1.31,2.34,2.34,0,0,1,2.23,1.55l.26-.34c-1.78-.55-3.56.6-5.32,0V68a29.82,29.82,0,0,0,3.13-1.35l-.24-.41-2.57,1.41c-.23.13-.07.53.19.44a14.62,14.62,0,0,0,2.71-1.36l-.28-.37-.78.79c-.2.2.06.47.29.37a8.06,8.06,0,0,0,1.38-.76c.25-.17,0-.57-.24-.41a9.75,9.75,0,0,0-1.47,1.08c-.21.18.06.51.29.37l1.6-1-.28-.36-.81.78c-.16.14,0,.47.22.38a4.43,4.43,0,0,0,1.19-.73l-.35-.27c-.08.14-.16.29-.23.44a.24.24,0,0,0,.2.35,1.94,1.94,0,0,1,1.17.3c.19.12.41-.16.24-.31a1.73,1.73,0,0,0-1.41-.46l.2.35a3.55,3.55,0,0,0,.21-.44.23.23,0,0,0-.35-.28,3,3,0,0,1-1,.61l.22.38.82-.77a.24.24,0,0,0-.28-.37l-1.61.94.29.38a9,9,0,0,1,1.37-1l-.24-.41a8.06,8.06,0,0,1-1.38.76l.29.37.77-.78a.24.24,0,0,0-.29-.38,13.2,13.2,0,0,1-2.6,1.31l.18.43,2.57-1.41c.27-.15,0-.55-.24-.41a27.68,27.68,0,0,1-3,1.29.24.24,0,0,0,0,.47c1.78.6,3.55-.57,5.33,0a.23.23,0,0,0,.26-.34,2.89,2.89,0,0,0-2.16-1.78c-1.22-.1-2,.78-2.81,1.6a.12.12,0,0,0,.18.17Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M36.53,69.51c.75,0,5.54-.84,5.88-.45,1.2,1.41-4.1,2.91-4.94,2.93a5.92,5.92,0,0,1-4.89-2.2c-1.46-1.82-1.13-5.44-4.12-5.57-.34,0-.32.49,0,.52,2.31.23,2.46,3.93,3.6,5.4A6.26,6.26,0,0,0,34.42,72a7.44,7.44,0,0,0,6.74-.47c.74-.43,2.58-1.42,2-2.53s-5.55.11-6.7.34c-.13,0-.09.22,0,.22Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M29.8,65c1.87,3,1.69,6.35,5.73,7,1.89.31,8.15.52,7.4-2.71a.22.22,0,0,0-.37-.09c-1.9,1.56-.48.53-.1.15.21-.21-.1-.51-.33-.32l-1.2,1c-.22.19.09.5.31.31.89-.75.48-1-.26-.22-.2.19.05.46.28.36-.08,0,1.16-.61,1.14-.62l-1.1,1.2a8.77,8.77,0,0,1-1.22.32c-1.88.4-4.78.59-6.5-.5-2.21-1.39-1.73-4.51-3.7-6a.06.06,0,0,0-.08.07Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M40.32,69.75a4.57,4.57,0,0,1,.5,2,3.9,3.9,0,0,1-.85,1.9c-.1.13.1.33.24.23,1.22-.91,1.61-3.23.32-4.27-.08-.07-.25,0-.21.12Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M38.6,69.27c-.69.86-1.35,1.74-2,2.62-.41.55-1.05,1.21-.62,1.9.05.09.21.06.2-.05-.05-.87.78-1.64,1.26-2.29s1-1.32,1.41-2c.1-.14-.13-.32-.24-.19Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M37.15,69.81a3.08,3.08,0,0,0-2,1.11,2.43,2.43,0,0,0-.54,2.23.11.11,0,0,0,.21,0,4.84,4.84,0,0,1,.68-2,2.88,2.88,0,0,1,1.73-1.07c.21,0,.12-.35-.09-.32Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M35.22,69a13.33,13.33,0,0,0-4.1,3.47.09.09,0,0,0,.13.12c1.44-1,2.65-2.36,4.08-3.41.11-.08,0-.26-.11-.18Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M32.94,68.59c-.88.77-1.73,1.55-2.59,2.35a13.07,13.07,0,0,0-2.2,2.26c-.07.1.06.23.17.17a13.81,13.81,0,0,0,2.36-2.1c.84-.81,1.66-1.63,2.47-2.47.14-.14-.07-.34-.21-.21Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M31.59,68.64c-1.49.73-3.05,1.07-4.27,2.29a3.72,3.72,0,0,0-1.25,3.25c0,.17.25.11.26,0,.32-2.85,3-4.24,5.28-5.48,0,0,0,0,0,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M31.84,66.1c-1.44.64-2.89,1.3-4.38,1.81a19.75,19.75,0,0,0-3,1c-1.2.64-1.93,1.87-1.19,3.13,0,.09.2,0,.16-.06-1-2.66,3.09-3.19,4.74-3.82a15.92,15.92,0,0,0,3.72-2,0,0,0,0,0,0-.07Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M31.92,66.89A65.09,65.09,0,0,0,24.67,70c-1.4.77-2.77,2.13-2.06,3.83a.16.16,0,0,0,.3-.08c-.8-3.82,6.66-5,9.07-6.67.07-.05,0-.19-.06-.15Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M20.05,70.13c-2.06.32-4.49.76-5.89-1.23l-.18.43c3.32-.5,7.11-2.14,9-5.08.12-.19-.14-.37-.3-.23-2.69,2.37-5.16,4.25-8.83,4.75a.3.3,0,0,0-.18.43c1.54,2.19,4.19,1.9,6.49,1.26.22-.06.12-.36-.09-.33Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M20.46,63.94a5.51,5.51,0,0,1-5.4-.89l-.28.49c3.48.82,6.43-1.75,8.26-4.47.12-.18-.15-.37-.3-.22-2.18,2.14-4.3,5-7.81,4.12-.27-.07-.51.29-.28.49a5.12,5.12,0,0,0,5.93.76.15.15,0,0,0-.12-.28Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M15.9,65.62c-1.31-.31-2.68-.17-4-.53a11.71,11.71,0,0,1-4.44-2.3A.3.3,0,0,0,7,63c.06,4.78,4.58,7.85,9.15,6.79a.17.17,0,0,0,0-.34,9.49,9.49,0,0,1-5.71-1.11A5.87,5.87,0,0,1,7.55,63L7,63.22C9.16,65,13.11,67,15.92,65.75c.06,0,0-.12,0-.13Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M14.37,70a16.63,16.63,0,0,1-5.7-2c-.24-.14-.54.15-.38.38,2.78,4.28,8.21,6.26,12.89,3.78.17-.09.05-.39-.14-.32-4.7,1.67-9.5.65-12.27-3.74l-.38.38a11.53,11.53,0,0,0,5.94,1.81c.14,0,.18-.23,0-.26Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M20.52,72.44A18,18,0,0,1,13.71,74a.31.31,0,0,0-.22.52c2.38,2.82,7.49,1.72,10-.32.13-.11,0-.29-.18-.22-2.63,1.34-7.1,2.91-9.41.11l-.21.52a14.63,14.63,0,0,0,7-1.82c.22-.12,0-.42-.19-.33Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M5.93,55.61c1.69,3.07,5.45,3.76,8.47,2.32.26-.13.07-.5-.19-.45A10.88,10.88,0,0,1,5.7,55.75c-.21-.15-.43.09-.39.29.76,4.07,4.81,7,8.9,5.56a.2.2,0,0,0-.11-.38C10.18,62,6.52,60,5.82,55.9l-.39.3A11.27,11.27,0,0,0,14.34,58l-.19-.45c-3,1.48-6,.47-8.11-2,0-.06-.15,0-.11.08Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M14.45,60.06A10.73,10.73,0,0,1,5,58.73c-.25-.18-.48.15-.38.38,1.4,3.22,4.42,6.1,8.08,6.29.17,0,.19-.23,0-.28-3.42-1.05-6.23-2.75-7.61-6.22l-.41.31a9.71,9.71,0,0,0,9.82,1.07c.13-.06,0-.26-.1-.22Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M7.49,49c-1.46-.22.86,2.47,1.17,2.73a6,6,0,0,0,6.36.92c.15-.08,0-.28-.1-.25a7.53,7.53,0,0,1-4.31,0,6.22,6.22,0,0,1-1.84-1.09c-.23-.2-1.93-2.06-1.28-2.23,0,0,0-.06,0-.06Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M6.64,49.3c-.66,1.67.28,4,1.28,5.35a4,4,0,0,0,4.39,1.28c.13,0,.09-.2,0-.22-1.64-.19-3.17,0-4.16-1.64a6.67,6.67,0,0,1-1.18-4.69.16.16,0,0,0-.3-.08Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M8.24,47c2.58,4.85,9.91,4.79,14,2.11a.09.09,0,0,0-.07-.16c-5.4,1.86-9.44,2-13.81-2-.05,0-.13,0-.1.08Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M20.79,43.27l-.36-.57.39-1.51c.38-.23,1,0,1.35.15.85.3,1.67.7,2.5,1,.31.13.59-.33.27-.47-1.09-.47-4.89-2.26-5.31,0a1,1,0,0,0,.86,1.18c.83,0,1.38-1,1.33-1.72a.25.25,0,0,0-.38-.22,1.66,1.66,0,0,0-.79,1.38.25.25,0,0,0,.31.23c.39-.15,1.34-.63,1-1.19-.42-.73-1.72.26-2,.61a.22.22,0,0,0,.27.35,4.15,4.15,0,0,0,1.16-.78c.18-.18-.06-.49-.27-.35s-1.49,1.14-1,1.68,1.63-.83,1.86-1.16l-.38-.23-.66,1a.22.22,0,0,0,.25.32,4.17,4.17,0,0,0,1.47-.89c.18-.17-.06-.5-.27-.35a5.45,5.45,0,0,0-.92.81.22.22,0,0,0,.27.35,3.91,3.91,0,0,0,1-.68L22.4,42l-.54.75a.22.22,0,0,0,.19.33.87.87,0,0,0,.54-.13l-.22-.37-.34.25.26.34.16-.2a.22.22,0,0,0-.09-.36,2.85,2.85,0,0,0-2.11,0,.23.23,0,0,0,0,.44,7,7,0,0,0,3,.46.2.2,0,0,0,0-.4,9.12,9.12,0,0,1-2.84-.5v.44A2.65,2.65,0,0,1,22.24,43l-.09-.36-.17.2c-.14.17.05.5.27.34l.34-.25a.22.22,0,0,0-.22-.37l-.32.06.19.33.54-.74c.15-.21-.17-.43-.35-.27a3.41,3.41,0,0,1-.9.61l.27.35a5.05,5.05,0,0,1,.84-.75l-.27-.35a3.52,3.52,0,0,1-1.27.79l.25.32.65-1c.16-.25-.22-.46-.38-.23s-.42.67-.79.74c-.58.11.43-.59.52-.65l-.26-.35a3.77,3.77,0,0,1-1.07.71l.27.35a1.42,1.42,0,0,1,.77-.55c.36,0,.65,0-.23.35l.31.24.55-.95-.38-.21c0,.76-.12.9-.45.4-.49-.33-.36-.47.38-.43a4.08,4.08,0,0,1,1.2.2,16.15,16.15,0,0,1,2.23.83l.27-.47c-1.19-.5-3.15-1.83-4.5-1.16s-.71,2,0,2.75a.2.2,0,0,0,.31-.24Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M13,39.3a2,2,0,0,0,1.29,2.46,4.49,4.49,0,0,0,3.86-.56.19.19,0,0,0-.14-.35,10.77,10.77,0,0,1-2.67.61,2,2,0,0,1-2.06-2.12c0-.17-.23-.18-.28,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M17.19,37.86a9.63,9.63,0,0,0,3,.81c1,.12,3.08-.51,4-.17.32.13.68,1.17,1,1.5.93.91,2.3,1.25,3.33,2,.16.12.35-.06.22-.21-1.09-1.27-3.94-1.74-3.85-3.84a.26.26,0,0,0-.32-.25,13.17,13.17,0,0,1-7.23-.16c-.16,0-.27.2-.12.27Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M21.24,36.42a27.94,27.94,0,0,0,3,1c1.07.33,3,.51,3.58,1.54.39.64.47,1.61.82,2.32a10.07,10.07,0,0,0,1.74,2.51c.17.19.43-.09.27-.28a12.12,12.12,0,0,1-2.49-5.27A.23.23,0,0,0,28,38.1a55.56,55.56,0,0,0-6.64-1.87c-.11,0-.2.14-.08.19Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M32.62,42.16c-1.24-.36-1.89-1.51-2.95-2.15a5.81,5.81,0,0,0-2.85-.88.13.13,0,0,0-.07.24c1.28.59,2.48.75,3.55,1.79a3.76,3.76,0,0,0,2.27,1.35c.2,0,.23-.3,0-.35Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M38.58,41.89c-3-1.41-6.86-2.22-8.77-5.24a.12.12,0,0,0-.23.09,5.67,5.67,0,0,0,3,3,23.92,23.92,0,0,0,5.88,2.37c.15,0,.27-.19.11-.26Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M40.35,38.65c-.46-.22-.41-.45.16-.69.16-.14,0-.4-.21-.35-.53.4-.81.36-.85-.11a.23.23,0,0,0-.26-.34c-.63.34-.82.3-.56-.11a.24.24,0,0,0-.27-.34,5,5,0,0,1-1,.38c-1.15-.09.34,0-.45-.35.13,0-.45-.72-.27-.49a.2.2,0,0,0-.22,0,4.16,4.16,0,0,1-2.21.37,2.7,2.7,0,0,0-1.06,0c-.19,0-.23.57-.33.59.52-.1-1-.69-1.14-.73s-.42.19-.28.37l-1.14-.31a.24.24,0,0,0-.19.44l.94.6c.27.17.51-.25.25-.43a29.52,29.52,0,0,0-4.86-2.76c-.19-.08-.3.22-.13.32A22.64,22.64,0,0,0,32,37.45c.19.06.4-.18.27-.35l.82.61c.16.14.49,0,.39-.23l1.1.14a.23.23,0,0,0,.28,0A1.73,1.73,0,0,1,36,37.1c.46-.22.56-.12.29.3-.06,0,.22.85.1.45a.23.23,0,0,0,.34.14,1.35,1.35,0,0,1,1-.41c-.12.18.08.39.27.35q.83-.55.69.18a.23.23,0,0,0,.25.33c.88-.24,1.07-.55.4.1a.2.2,0,0,0,.14.34l.87,0c.11,0,.14-.17,0-.19Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M8.87,45a8.64,8.64,0,0,0,11,1.36.28.28,0,0,0-.29-.49A8.71,8.71,0,0,1,9.16,44.71a.21.21,0,0,0-.29.29Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M34.69,59.91c.34-.09.49-.38.89-.37s.61.38.91.63c.08.07.25.06.27-.07.07-.55-.5-1-1-1s-1.23.21-1.2.74a.11.11,0,0,0,.14.11Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M44.54,58.79c1,.11.12,1.81,0,2.19a4.67,4.67,0,0,0-.28,1.47.1.1,0,0,0,.19.06A14.16,14.16,0,0,0,45,61a6.35,6.35,0,0,0,.49-1.51c0-.56-.36-1.13-1-.92a.13.13,0,0,0,0,.26Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M41.41,57.76a11.07,11.07,0,0,0-.79,4.75c0,.15.25.21.28,0a41.65,41.65,0,0,1,.83-4.7c.06-.21-.24-.28-.32-.09Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M46.42,51.65a9.28,9.28,0,0,1,2.06.64.19.19,0,0,0,.22,0c.78-.76-1.33-1-1.64-1.08l-.09.35c.4.07.81.15,1.22.19a.15.15,0,0,0,.11-.26,3.62,3.62,0,0,0-1.18-.66l-.08.31a7.22,7.22,0,0,1,.89.31c.12.06.26-.09.15-.19l-.48-.44-.15.26.2,0c.12,0,.26-.1.18-.23a2.12,2.12,0,0,0-2.68-.9.15.15,0,0,0,.12.28,2,2,0,0,1,2.28.78l.14-.24-.2,0c-.17,0-.18.22-.08.3s.34.26.52.38l.12-.21a3.7,3.7,0,0,0-.93-.41.16.16,0,0,0-.08.31,3.2,3.2,0,0,1,1,.57l.15-.26c-.39-.1-.78-.17-1.17-.24a.18.18,0,0,0-.09.35l1,.22c.19.05.78.24.2,0a5.61,5.61,0,0,0-1.71-.4.14.14,0,0,0,0,.28Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M34.52,43.18a9.68,9.68,0,0,1-.27,1.06,4.17,4.17,0,0,1-.24.58q-.12.72-.54,0a.27.27,0,0,0-.45-.26c-.54.56-1.08,1.12-1.61,1.69l.42.32c.17-.33.33-.67.5-1s-.06-.46-.28-.37l-2.92,1.12c-.3.12-.19.58.13.49a13.68,13.68,0,0,0,4.92-2.51l-.39-.3-.56.82c-.17.25.23.48.41.23l.74-1L34,43.86,33.54,45l.44.12.28-.71-.42-.18a2.61,2.61,0,0,1-.62,1.2l.35.28c.28-.57.55-1.14.83-1.7.13-.26-.25-.49-.39-.23a7,7,0,0,1-1.48,1.78l.37.29a6.56,6.56,0,0,1,1.46-1.89L34,43.61a12.85,12.85,0,0,1-2.12,1.77l.27.35,1.86-1.84c.2-.19-.09-.46-.3-.29a15.92,15.92,0,0,1-3.45,2.14l.22.37,2.74-1.75L33.05,44a18.49,18.49,0,0,1-3.89,2.27l.23.39c1.46-.75,3.94-1.44,4.53-3.15h-.45l.18.66a.22.22,0,0,0,.43,0l.12-.37-.4.05.16.25a.22.22,0,0,0,.4-.05l.17-.44-.4,0,.13.18a.22.22,0,0,0,.41-.11l0-.35c0-.21-.31-.32-.41-.11l-.22.41h.38l-.22-.4a.23.23,0,0,0-.37-.1,18.64,18.64,0,0,1-5,3,.25.25,0,0,0-.05.44,1.52,1.52,0,0,0,1.39.15,26.31,26.31,0,0,0,2.93-.48c1.38-.42,1.9-1.74,2.17-3a.2.2,0,0,0-.39-.11C34.4,44.57,34,45.73,32.41,46c-.51.09-1,.06-1.54.15s-1.34.52-1.88.11l-.06.43a18.25,18.25,0,0,0,5.19-3.19l-.37-.1a1.51,1.51,0,0,0,.27.5.22.22,0,0,0,.38,0l.22-.41-.41-.11,0,.35.41-.11-.13-.18a.22.22,0,0,0-.4.05l-.18.44.41,0-.16-.25a.22.22,0,0,0-.4,0l-.13.37h.43c0-.22-.11-.44-.16-.67a.24.24,0,0,0-.45,0c-.49,1.44-3.07,2.24-4.31,2.89-.27.14,0,.5.23.39a18,18,0,0,0,3.91-2.33c.19-.15,0-.46-.25-.33L30.3,45.74a.22.22,0,0,0,.22.37,15.22,15.22,0,0,0,3.53-2.22l-.3-.29-1.87,1.81c-.18.18.05.5.27.36a13.49,13.49,0,0,0,2.21-1.84.23.23,0,0,0-.32-.32,6.42,6.42,0,0,0-1.54,2,.23.23,0,0,0,.36.28A7.14,7.14,0,0,0,34.4,44L34,43.75c-.28.56-.55,1.13-.83,1.7-.1.21.19.49.36.27a4.18,4.18,0,0,0,.74-1.4.22.22,0,0,0-.41-.17,2.25,2.25,0,0,0-.33.82.23.23,0,0,0,.44.12L34.4,44c.1-.26-.28-.38-.42-.18l-.75,1,.41.23.58-.8c.17-.25-.19-.46-.39-.3a13.54,13.54,0,0,1-4.7,2.37l.13.49,2.92-1.13-.28-.37-.53,1a.27.27,0,0,0,.42.32c.54-.55,1.08-1.12,1.61-1.68L33,44.71c-.12.51-.12,1.36.64,1.32,1-.05,1.3-2.08,1.42-2.71.06-.32-.43-.46-.49-.14Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M26.29,50a40.22,40.22,0,0,0-4.11,0l.14.54a4.23,4.23,0,0,1,4,.17l.07-.5c-1.78.48-3.58-.43-5.42.1a12.09,12.09,0,0,0-3.93,2.2c-.14.11,0,.32.18.24,1.71-.94,3.46-2.14,5.49-2.17,1.36,0,2.48.52,3.83.15a.28.28,0,0,0,.06-.5,5,5,0,0,0-4.51-.22.29.29,0,0,0,.08.56,37.54,37.54,0,0,0,4.11-.13.2.2,0,0,0,0-.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M39.6,43.47a6.42,6.42,0,0,0,.91,1.64,3.53,3.53,0,0,0,.57.59,3.45,3.45,0,0,0,.49.32c.06,0,.92.49.35.63a.12.12,0,0,0,0,.24c.56,0,.48-.65.14-.91a7,7,0,0,1-1.36-1.07,14.79,14.79,0,0,1-.94-1.52c-.06-.1-.23,0-.19.08Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M43.62,46.16a2.35,2.35,0,0,0-1-2.11,3.67,3.67,0,0,1-.78-.49c-.24-.29-.16-.75-.23-1.09a.78.78,0,0,0-.39-.64.11.11,0,0,0-.15.15c.37.65.06,1.44.7,1.94.24.18.53.28.78.46a2.33,2.33,0,0,1,1,1.78.06.06,0,1,0,.11,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M38.94,41.32a1.82,1.82,0,0,1,.88,1c.06.2,0,.42.08.61s.13.28.35.42.74.33.93.73c.06.14.08.29.14.43a.8.8,0,0,0,.62.57.12.12,0,0,0,.09-.22c-.51-.39-.42-1-.78-1.47-.24-.31-.55-.29-.83-.52s-.3-.77-.57-1.14a1.69,1.69,0,0,0-.85-.59c-.08,0-.12.09-.06.13Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M27,57a7.13,7.13,0,0,0-1.73,6.54.2.2,0,0,0,.39,0c.17-.91.61-1.49.84-2.39.39-1.49-.06-.43-.22-.12a5.92,5.92,0,0,0-.5,3.11.21.21,0,0,0,.4,0c.16-.57,1.16-2.34,1.11-2.52.15.57-.56,2.45-.69,3.09a.2.2,0,0,0,.36.15,9.33,9.33,0,0,0,1-1.47c.11-.24,0-.55-.07-.39a6.41,6.41,0,0,0-.37,2.81c0,.22.35.29.39.06a7.35,7.35,0,0,0,.28-1.72c-.06-1-.31.91-.31,1a7.25,7.25,0,0,0,.11,2.13c0,.21.33.16.39,0a32.2,32.2,0,0,1,2.62-5.09c.11-.18-.16-.32-.28-.16a37.88,37.88,0,0,0-2.16,3.75c-.3.5-.21,1.22-.33.1a5.77,5.77,0,0,1,.56-2.58c.08-.21-.25-.34-.35-.15a8.8,8.8,0,0,0-.7,1.64q-.3.42.15.36a6.06,6.06,0,0,1,.65-2.6.2.2,0,0,0-.34-.2,12.92,12.92,0,0,0-1,1.75,17.87,17.87,0,0,0,.61-3,.2.2,0,0,0-.36-.16A11.86,11.86,0,0,0,26,63.29c-.12.27-.23,1.08.21-.93a6.27,6.27,0,0,1,1-2.21c.12-.19-.17-.41-.31-.24a7.78,7.78,0,0,0-1.13,1.65l-.27.65c-.19.7-.24.84-.14.41-.29-.25.15-2,.24-2.42a7.1,7.1,0,0,1,1.59-2.88c.16-.19-.1-.46-.27-.28Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M26,56.3a7.75,7.75,0,0,0-2,9c.08.21.47.22.44-.06a9.32,9.32,0,0,1,3.41-8.4c.21-.17-.09-.46-.3-.29a9.76,9.76,0,0,0-3.56,8.69l.44-.06a7.79,7.79,0,0,1,1.77-8.68A.12.12,0,0,0,26,56.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M39.21,58.89c.14.62.31,1.24.43,1.86a7,7,0,0,1-.08,2.74,1.27,1.27,0,0,0,.6,1.51c.25.14.48-.25.22-.39-.76-.41-.07-2.3-.16-3.09a21.32,21.32,0,0,0-.58-2.75c-.06-.28-.5-.16-.43.12Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M37.67,63.67a1.45,1.45,0,0,0,1.78-1.36c0-.29-.44-.29-.45,0a1,1,0,0,1-1.21.92c-.28-.06-.4.37-.12.44Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M38.78,64.37a2,2,0,0,0,1-1.62c0-.29-.43-.29-.45,0A1.54,1.54,0,0,1,38.55,64a.23.23,0,0,0,.23.39Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M34.59,58.17A6.71,6.71,0,0,1,39.69,57a.22.22,0,0,0,.12-.43,5.88,5.88,0,0,0-5.33.69c-.24.17,0,.56.23.39a5.45,5.45,0,0,1,5-.65l.12-.43a7.14,7.14,0,0,0-5.44,1.19c-.24.17,0,.56.22.39Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M47.43,59.22l.33-.59c.12-.21-.19-.48-.35-.27L44.6,61.89c-.18.23.14.55.32.32l2.81-3.53-.36-.28L47,59c-.14.25.25.48.39.22Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M49.68,53.73l.55-.81a.23.23,0,0,0-.13-.33,2.55,2.55,0,0,1-.84-.57c-.2-.21-.52.11-.32.32A3.12,3.12,0,0,0,50,53l-.13-.33-.56.81c-.17.24.22.47.39.23Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M44.27,52.39a.86.86,0,0,0,.21.75c.15.18.43,0,.38-.22a.7.7,0,0,1,.57-.88c.28,0,.16-.48-.12-.43A1.16,1.16,0,0,0,44.42,53l.38-.22-.09-.31c0-.29-.4-.41-.44-.12Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M46.87,53.15l-.16-.21-.19.33.3.39c0,.29.43.29.45,0a.78.78,0,0,0-.75-.84.23.23,0,0,0-.19.34l.15.22c.16.23.55,0,.39-.23Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M46.44,53.33a.42.42,0,0,1,.66.15c.11.27.54.15.44-.12A.88.88,0,0,0,46.12,53c-.22.2.1.51.32.32Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M46.7,53.5a.35.35,0,0,1,.53.17c.1.27.53.16.43-.12a.8.8,0,0,0-1.18-.44.22.22,0,0,0,.22.39Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M46.7,53.51a.15.15,0,0,1,.24.09c0,.29.48.29.45,0a.6.6,0,0,0-1-.41c-.22.19.1.5.32.32Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M49,53.67a.51.51,0,0,0-.67.37.23.23,0,0,0,.33.26l1.48-.76c.26-.13,0-.52-.23-.39l-1.47.76.33.25.11-.06a.22.22,0,0,0,.12-.43Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M48.63,54.35,49.78,54a.22.22,0,0,0-.12-.43l-1.15.36c-.28.08-.16.52.12.43Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M46.79,51a.23.23,0,0,0,0-.45.23.23,0,0,0,0,.45Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M45.25,50.18l-.51-.09-.11.43,2,.28.06-.45L45,50.53A.23.23,0,0,0,45,51l1.57.09-.06-.44a4.53,4.53,0,0,1-1.27.08c-.29,0-.29.43,0,.45l1.47.11v-.45L45.14,51a.23.23,0,0,0,0,.45l1.22.06c.29,0,.29-.43,0-.45a34.84,34.84,0,0,0-4.9,0c-.29,0-.29.47,0,.45a34.84,34.84,0,0,1,4.9,0v-.45L45.14,51v.45l1.54-.19a.23.23,0,0,0,0-.45l-1.47-.11v.45a5.37,5.37,0,0,0,1.39-.1c.26-.05.19-.43-.06-.44L45,50.53V51l1.69-.18c.23,0,.34-.4.06-.44l-2-.27c-.27,0-.4.38-.11.43l.5.1c.29.05.41-.38.12-.44Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M41.63,46.29a4.21,4.21,0,0,1-2.08,1.27c-.26.07-.17.41.06.44a2.46,2.46,0,0,0,1.23-.14.23.23,0,0,0-.06-.44,2.41,2.41,0,0,0-1.21.3c-.26.13,0,.52.23.39a2,2,0,0,1,1-.24l-.06-.44a2.33,2.33,0,0,1-1.11.12l.06.44A4.61,4.61,0,0,0,42,46.61c.2-.22-.12-.54-.32-.32Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M39.7,45l-.19-.13a.23.23,0,0,0-.28.35l1,1c.21.2.52-.12.32-.32l-1-1-.27.36.2.13c.24.16.47-.23.22-.39Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M38.65,46.17l-.56.75c-.15.2.2.47.36.27l.6-.77c.15-.19,0-.49-.27-.35l-1,.57L38,47l.44-.29a.23.23,0,0,0-.18-.41.83.83,0,0,1-.73-.19c-.22-.18-.54.14-.32.32a1.33,1.33,0,0,0,1.17.3l-.17-.41-.44.29A.23.23,0,0,0,38,47l1-.57-.27-.36-.6.77.35.28L39,46.4c.17-.23-.22-.46-.39-.23Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M39.09,46.19a1.62,1.62,0,0,0-.83.38l.32.32.25-.3c.16-.18,0-.51-.27-.35s-.28.22-.58.13-.49-.18-.73-.27-.38.33-.11.43l.54.21a2.37,2.37,0,0,0,.54.2c.23,0,.39-.18.57-.31l-.27-.36-.26.3a.23.23,0,0,0,.32.32,1.27,1.27,0,0,1,.63-.27c.29,0,.16-.48-.12-.43Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M39,46.17l-.33.31.32.32.47-.6c.18-.22-.1-.52-.31-.31l-.58.54.22-.06L37.06,46c-.29-.05-.41.38-.12.44.54.1,1.08.24,1.63.31s.62-.32.89-.58l-.31-.31-.48.59c-.17.22.1.52.32.32l.33-.31c.21-.2-.1-.52-.32-.32Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M35.09,43.76l-.26,1.37.32.32a2.3,2.3,0,0,0,.57-1.54l-.44.05c.52,2.82-4.6,3.16-6.35,3-.29,0-.28.42,0,.45,2.13.19,7.37-.35,6.78-3.57,0-.26-.43-.19-.44.06l-.44,1.22c-.17.22.11.53.32.32a1.57,1.57,0,0,0,.38-1.81c-.11-.27-.54-.15-.44.12Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M22.8,42.88a1.6,1.6,0,0,1-1.64-1.53l-.23.23h.42a.23.23,0,0,0,.06-.45,1.05,1.05,0,0,0-1.1.3.22.22,0,0,0,.1.37l.52.12.06-.44h-.32c-.29,0-.29.43,0,.45H21a.22.22,0,0,0,.06-.44l-.52-.12.1.38a.59.59,0,0,1,.66-.18l.06-.44h-.42a.23.23,0,0,0-.22.22,2.05,2.05,0,0,0,2.09,2c.29,0,.29-.46,0-.45Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M21.83,42.21a1,1,0,0,1,1.16.18c.2.21.52-.11.32-.32a1.44,1.44,0,0,0-1.71-.25c-.26.14,0,.53.23.39Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M21.73,42.27a.23.23,0,0,0,0-.45.23.23,0,0,0,0,.45Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M21.85,42.26a1.62,1.62,0,0,1,1.74.14c.24.17.46-.22.23-.39a2.07,2.07,0,0,0-2.19-.14c-.26.13,0,.52.22.39Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M21.51,42.09a2,2,0,0,1,2.32.36c.2.2.52-.12.31-.32a2.44,2.44,0,0,0-2.86-.43c-.26.14,0,.52.23.39Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M21.45,42.3a3.48,3.48,0,0,1,2.7.22c.26.13.49-.26.23-.39a4,4,0,0,0-3.05-.26c-.27.08-.16.52.12.43Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M21.17,41.82a3.81,3.81,0,0,1,2.85.51c.25.15.47-.24.23-.39a4.28,4.28,0,0,0-3.2-.55c-.28.06-.16.5.12.43Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M21.35,41.92a5.35,5.35,0,0,1,3.48.66c.25.14.48-.25.23-.39a5.88,5.88,0,0,0-3.83-.7c-.28,0-.16.47.12.43Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M21.47,41.92a5.06,5.06,0,0,1,3,.84c.25.16.47-.23.23-.39a5.51,5.51,0,0,0-3.23-.9c-.29,0-.29.46,0,.45Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M21.32,41.72l3.64,1a.23.23,0,0,0,.12-.44l-3.64-1a.22.22,0,0,0-.12.43Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M20.28,41.65a4.92,4.92,0,0,1,3,.32c.26.11.49-.28.23-.39a5.45,5.45,0,0,0-3.38-.36c-.28.05-.16.49.12.43Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M19.87,42a6.6,6.6,0,0,1,4.19.85c.25.15.48-.24.23-.38a7,7,0,0,0-4.42-.92c-.28,0-.29.49,0,.45Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M20.34,42.53l3.11.45c.28,0,.41-.39.12-.44l-3.11-.44c-.28,0-.41.39-.12.43Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M20.87,43.08l2.67.44c.28,0,.4-.38.12-.43L21,42.65c-.28,0-.4.39-.12.43Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M20,43.07a11.46,11.46,0,0,0,3.8.7c.29,0,.29-.44,0-.45a11.25,11.25,0,0,1-3.68-.68c-.27-.1-.39.33-.12.43Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M20.11,43.4a5.13,5.13,0,0,0,4.08.28c.27-.09.16-.52-.12-.43A4.73,4.73,0,0,1,20.33,43c-.25-.13-.48.26-.22.39Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M20.7,43.33a4.92,4.92,0,0,0,3.82-.19c.26-.13,0-.51-.23-.39a4.52,4.52,0,0,1-3.48.15c-.27-.1-.39.34-.11.43Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M21,43.51a5.67,5.67,0,0,0,3.24-.61c.26-.14,0-.53-.22-.39a5.35,5.35,0,0,1-3,.55c-.28,0-.28.42,0,.45Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M21,43.34a11.55,11.55,0,0,0,4.42-.89c.26-.11.15-.55-.12-.44a11.13,11.13,0,0,1-4.3.88.23.23,0,0,0,0,.45Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M21.35,43.23l3.64-.8c.28-.06.16-.49-.12-.43l-3.64.8c-.29.06-.17.5.12.43Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M20.64,43.27l3.83-1a.22.22,0,0,0-.12-.43l-3.83,1c-.28.07-.16.51.12.44Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M20.11,43.07l3.19-.89a.22.22,0,0,0-.11-.43l-3.2.88a.23.23,0,0,0,.12.44Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M27.08,41c-2.14-1.5-6.89-3.95-9.1-1.32s1.46,5,3.61,5.6a.23.23,0,0,0,.12-.44,5.14,5.14,0,0,1-3.38-2.12C17.14,40.61,18.89,39,21,39a11.28,11.28,0,0,1,5.81,2.33c.24.16.47-.23.23-.39Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M22.16,44.61a11,11,0,0,1-2.86-1.16c-1-.69-.95-.88-.61-2.1s.55-1.4,1.86-1.52a7.66,7.66,0,0,1,5.62,1.6c.22.18.54-.14.32-.32-1.88-1.54-5.95-2.82-8.09-1A2,2,0,0,0,18,42.71C18.76,44.2,20.6,44.54,22,45c.28.09.4-.34.12-.43Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M26.09,40.73a5.53,5.53,0,0,0-4.28-1.68c-1.28,0-3.07-.12-4.1.83A2.47,2.47,0,0,0,17.43,43c.78,1.4,2.47,1.88,3.9,2.28a.22.22,0,0,0,.12-.43,7,7,0,0,1-3.11-1.41,2,2,0,0,1-.45-2.61c.51-1,.84-1.09,1.91-1.22,2.06-.24,4.52-.18,6,1.49.19.22.5-.1.32-.32Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M21.45,44.73A12.21,12.21,0,0,1,19,43.35l-.86-.7.75-2.24c.31-.3,1.21-.34,1.59-.4a8.9,8.9,0,0,1,5.8,1.09.22.22,0,0,0,.22-.39c-2.35-1.31-6.43-2.09-8.78-.25s2.31,4.14,3.66,4.7c.27.12.38-.32.12-.43Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M26.89,40.86a15,15,0,0,0-5.59-1c-1.13,0-3.08,0-3.81,1.09-1.46,2.2,1.85,4,3.62,3.92.29,0,.29-.46,0-.45-1.22.06-3.22-.55-3.4-2.09-.23-2.07,2.41-2,3.59-2a14.62,14.62,0,0,1,5.47,1c.27.1.39-.34.12-.44Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M21.41,44.94a24.47,24.47,0,0,1-2.28-1.31c-.32-.22-1.38-.75-1.46-1.08l.89-2.07a6.57,6.57,0,0,1,1-.28,11.22,11.22,0,0,1,7.33.74c.26.11.49-.28.23-.39-2.63-1.18-7-2-9.57,0s2.42,4.16,3.68,4.81c.25.13.48-.25.22-.39Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M9.57,44.88A10.58,10.58,0,0,0,20.42,46.6c.44-.18.25-.91-.2-.73A9.81,9.81,0,0,1,10.1,44.35c-.37-.31-.9.22-.53.53Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M9,47.27A13.05,13.05,0,0,0,22.28,49.6c.44-.17.25-.89-.2-.72A12.3,12.3,0,0,1,9.5,46.74c-.37-.32-.9.21-.53.53Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M7.48,49.38a9.7,9.7,0,0,0,8.29,3.48c.48,0,.49-.79,0-.75A9,9,0,0,1,8,48.85c-.3-.37-.83.16-.53.53Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M14.16,58.61l-3.25.54a5.83,5.83,0,0,1-1.71.24,2.48,2.48,0,0,1-1.75-2,.38.38,0,0,0-.74.1c0,1.29,1.61,1.87,2.69,2.16a13.74,13.74,0,0,0,5.42,0c.47-.07.27-.79-.2-.72a17.77,17.77,0,0,1-3.71.25c-.79,0-3.44-.45-3.45-1.64l-.73.1c.29,1.1.73,2.23,2,2.49a5.67,5.67,0,0,0,2.13-.17l3.54-.59c.47-.08.27-.8-.2-.72Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M7.56,61.8c1.74,2,4.21,2.86,6.74,3.41a.38.38,0,0,0,.2-.73A44.6,44.6,0,0,1,8.12,61.4l-.29.69a22.71,22.71,0,0,0,5.32,1.29c.39,0,.5-.52.19-.69-1-.56-1.89.58-1,1.35l.45-.58a7.85,7.85,0,0,0-2.89-.93,5.8,5.8,0,0,1-3.56-2.64c-.26-.41-.9,0-.65.38a6.55,6.55,0,0,0,2.56,2.45c1.32.69,3,.52,4.17,1.38.34.25.77-.31.45-.59l.08-.18.19-.7A21.55,21.55,0,0,1,8,61.37c-.4-.16-.65.47-.29.68a47.1,47.1,0,0,0,6.56,3.16l.2-.73C12.09,64,9.75,63.2,8.09,61.27c-.32-.36-.84.17-.53.53Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M12.32,68.26A15.21,15.21,0,0,0,22.55,65c.38-.29-.15-.82-.53-.53a14.4,14.4,0,0,1-9.7,3.05c-.49,0-.49.72,0,.75Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M17.65,64.18a5.79,5.79,0,0,0,5.48-3.5c.15-.35-.28-.81-.59-.46a12,12,0,0,1-4.87,3.44c-.37.14-.36.75.1.73a14.06,14.06,0,0,0,4.06-.74c.46-.15.26-.88-.2-.72a13.71,13.71,0,0,1-3.86.71l.1.74a12.56,12.56,0,0,0,5.2-3.63l-.59-.45a5,5,0,0,1-4.83,3.13c-.48,0-.48.73,0,.75Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M11.65,70.76a13.44,13.44,0,0,0,11.44.84c.45-.17.26-.9-.2-.73A12.67,12.67,0,0,1,12,70.11c-.42-.23-.8.42-.38.65Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M11.77,70.4a14.09,14.09,0,0,0,3.36.45.37.37,0,0,0,.1-.73,8.44,8.44,0,0,0-3.46-.46.38.38,0,0,0-.26.64,5.27,5.27,0,0,0,2.43,1.55c.35.11.65-.38.37-.62l-1.06-.93-.37.63,2.32.53a.37.37,0,0,0,.2-.72,6.15,6.15,0,0,0-1.91-.25c-.5,0-.47.69,0,.75l3.13.34c.42,0,.51-.64.1-.73a9.1,9.1,0,0,0-3.41-.19.38.38,0,0,0-.1.74,21.48,21.48,0,0,0,5.75.83v-.75c-1.75,0-3.49,0-5.23-.13a.38.38,0,0,0-.1.74,18.25,18.25,0,0,0,8.81-.24.38.38,0,0,0-.2-.73,17.35,17.35,0,0,1-8.41.25l-.1.73c1.74.12,3.48.17,5.23.13a.38.38,0,0,0,0-.75,20.85,20.85,0,0,1-5.55-.8l-.1.73a8.9,8.9,0,0,1,3.21.16l.1-.74-3.13-.34v.75a3.85,3.85,0,0,1,1.71.22l.2-.72-2.32-.53c-.34-.08-.66.36-.36.62l1.06.93.36-.63A4.62,4.62,0,0,1,12,69.77l-.27.64a8.2,8.2,0,0,1,3.26.43l.1-.74A13.5,13.5,0,0,1,12,69.68c-.47-.12-.67.61-.2.72Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M24.49,61.57a7.27,7.27,0,0,0-.7,3.84c0,.34.52.55.7.19a11.12,11.12,0,0,0,.89-2.28l-.73-.1v2.31c0,.5.69.46.75,0l.24-1.87-.73.09L25.29,66c.07.41.6.29.72,0l.71-1.72L26,64.22l-.19,1.42c-.06.43.62.5.73.1l.37-1.32-.72-.2-.25,1.87c-.05.37.5.72.68.29L27.2,65l-.7-.19-.06,1.27c0,.41.5.46.7.19A2.41,2.41,0,0,0,27.62,65h-.75c0,.5-.24,1.58.55,1.64s.83-.66.79-1.17-.76-.49-.75,0l0,1.48c0,.3.43.54.64.27a3.74,3.74,0,0,0,.79-1.67H28.2l.22,1.28c.06.39.61.31.72,0l.51-1.46-.74-.1v1.49a.38.38,0,0,0,.7.19l.45-.88-.7-.19v.66a.37.37,0,0,0,.56.32l.24-.17c.4-.27,0-.92-.37-.65l-.25.17.57.33v-.66a.38.38,0,0,0-.7-.19l-.45.88.7.19V65.28a.37.37,0,0,0-.73-.1l-.51,1.46h.72l-.22-1.28a.38.38,0,0,0-.72,0,3,3,0,0,1-.6,1.34l.64.26,0-1.48h-.75c.24,0,.29-.16.16-.47,0-.5-.7-.47-.75,0a1.41,1.41,0,0,1-.38.88l.7.19.06-1.27c0-.35-.55-.53-.7-.19L26,66l.69.29.25-1.87c.07-.46-.58-.68-.72-.2l-.37,1.32.74.1.19-1.42c.06-.46-.59-.45-.74-.1l-.71,1.71H26l-.37-2.27c-.08-.46-.69-.28-.74.1l-.24,1.87h.75V63.22a.38.38,0,0,0-.74-.1,10,10,0,0,1-.82,2.1l.7.19a6.45,6.45,0,0,1,.6-3.46c.21-.43-.44-.81-.65-.38Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M24,62.65A28.79,28.79,0,0,1,24,65.73c0,.41.65.52.73.1l.47-2.26-.74-.1.26,2.35a.38.38,0,0,0,.74.1l.6-2.16-.74-.1.31,2.67a.38.38,0,0,0,.7.19,9.91,9.91,0,0,0,1-2.23l-.74-.1,0,2.22c0,.35.53.54.7.19l.78-1.67-.7-.19a7.63,7.63,0,0,0,.16,2.08.37.37,0,0,0,.68.09l.61-1.35-.68-.09.27,1.47a.37.37,0,0,0,.62.16,5,5,0,0,0,1.13-1.47l-.68-.09.63,1.56a.37.37,0,0,0,.73-.1c.37-3.07-3.22-3.12-5.29-2.72-.34.06-.33.52-.09.68.64.44,2.69.35,2.86,1.08.09.43.71.3.73-.1l.08-1.2-.73.1L29,66.15a.37.37,0,0,0,.72-.2c-.69-2.66-3.84-1.13-5.61-2.11v.65l.93-.3a.38.38,0,0,0,.27-.64,1.25,1.25,0,0,0-1.19-.44c-.33,0-.56.52-.19.7l1.56.76v-.65a2.92,2.92,0,0,0-1.35,3.43l.63-.36-.51-1-.46.46a20.17,20.17,0,0,0,4.85,1.09c.42.05.52-.65.1-.73a18.14,18.14,0,0,0-4.29-.39c-.41,0-.53.66-.1.74a44.84,44.84,0,0,0,5.9.72v-.75a3.41,3.41,0,0,1-1.55-.27v.72l1.21-.16a.38.38,0,0,0,.16-.63l-.42-.39c-.25-.23-.78,0-.63.37a2.91,2.91,0,0,0,.78,1.14c.27.24.75,0,.63-.36l-.15-.45-.72.2a18.64,18.64,0,0,0,1.57,3,.37.37,0,0,0,.64-.38l-1.1-2.58-.65.38,1.38,2a.38.38,0,0,0,.65-.38l-.73-1.58c-.18-.39-.8-.11-.68.29l.64,2.2.63-.37A9.81,9.81,0,0,0,28,67.3c-.7-.23-1.42-.28-2.13-.44-2.52-.57-2.19-2.27-1.46-4.15.17-.45-.56-.64-.73-.19-.6,1.55-1.17,3.84.73,4.77a15.47,15.47,0,0,0,2.88.58,8.9,8.9,0,0,1,4.11,2.48A.37.37,0,0,0,32,70l-.64-2.2-.68.29.72,1.58.65-.38-1.38-2a.38.38,0,0,0-.65.38l1.11,2.58.64-.38a17.65,17.65,0,0,1-1.49-2.78c-.18-.43-.87-.27-.72.2l.15.45.62-.37-.59-.81-.62.36.42.39.17-.63-1.21.17c-.4.06-.32.62,0,.72a5.28,5.28,0,0,0,1.75.3c.49,0,.48-.72,0-.75a45.48,45.48,0,0,1-5.7-.69l-.1.73a17.59,17.59,0,0,1,4.09.36l.1-.74A19.49,19.49,0,0,1,24,65.68a.38.38,0,0,0-.47.46,2.77,2.77,0,0,0,.71,1.38c.25.29.72,0,.63-.37a2.19,2.19,0,0,1,1-2.58.38.38,0,0,0,0-.65l-1.56-.76-.19.7.66.22.26-.64a2,2,0,0,0-1.31.4.38.38,0,0,0,0,.65c1.41.77,4.79-.19,5.27,1.66l.72-.2-.53-1.31a.38.38,0,0,0-.74.1l-.08,1.2.74-.1c-.36-1.61-2.16-.81-3.2-1.52L25.8,65c1.58-.3,4.65-.56,4.34,2l.74-.1-.63-1.56a.37.37,0,0,0-.68-.08,4.78,4.78,0,0,1-1,1.31l.63.17-.27-1.47a.39.39,0,0,0-.69-.09l-.61,1.35.69.09a6.63,6.63,0,0,1-.13-1.88.38.38,0,0,0-.7-.19l-.78,1.67.7.19,0-2.22a.38.38,0,0,0-.74-.1,9,9,0,0,1-.91,2l.7.19-.31-2.67a.38.38,0,0,0-.74-.1l-.6,2.16.74.1-.26-2.35c0-.38-.64-.55-.73-.1L24,65.63l.74.1a28.79,28.79,0,0,0-.07-3.08c0-.47-.79-.48-.75,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M36,67.18a1.53,1.53,0,0,1,1-1l-.48-.36.09,1.86c0,.48.77.48.75,0l-.09-1.86a.37.37,0,0,0-.47-.36A2.34,2.34,0,0,0,35.24,67c-.16.45.56.65.73.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M42.33,65v.31c0,.35.54.54.7.19a1.41,1.41,0,0,1,.52-.64L43,64.61a13.17,13.17,0,0,1,.12,2.94c0,.48.72.48.75,0a14.37,14.37,0,0,0-.14-3.14.38.38,0,0,0-.55-.22,2.05,2.05,0,0,0-.8.9l.7.19V65a.38.38,0,0,0-.75,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M43.5,65a8.41,8.41,0,0,1-.68,3c-.19.44.45.82.65.38A9.42,9.42,0,0,0,44.25,65c0-.48-.73-.48-.75,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M43.76,64.79l-.62,2.39a.38.38,0,0,0,.73.2l.62-2.4a.38.38,0,0,0-.73-.19Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M43.75,64.71a16.55,16.55,0,0,1-.7,3.1c-.15.46.58.65.73.2a17.84,17.84,0,0,0,.72-3.3c.06-.48-.69-.48-.75,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M43.58,65.24a9.27,9.27,0,0,1-.71,2.83c-.18.45.54.64.73.2a10.17,10.17,0,0,0,.73-3c0-.48-.71-.48-.75,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M44.17,65.07a20.46,20.46,0,0,1-1.1,2.81c-.21.44.44.82.65.38a21.43,21.43,0,0,0,1.17-3,.37.37,0,0,0-.72-.19Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M44.1,65.13l-1,2.4c-.19.45.54.64.72.2l1-2.4c.18-.44-.55-.64-.73-.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M44.28,65.16l-1.7,3.63c-.21.44.44.82.65.38l1.7-3.64c.2-.43-.44-.81-.65-.37Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M44,65.59a10.2,10.2,0,0,1-1.4,2.75c-.28.39.37.77.65.38a10.74,10.74,0,0,0,1.47-2.93c.15-.46-.57-.66-.72-.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M36.12,66.23a7.41,7.41,0,0,1,.17,2.3c0,.48.71.48.75,0a8.06,8.06,0,0,0-.19-2.5.38.38,0,0,0-.73.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M36.67,65.59,36.24,68c-.08.47.64.67.73.2l.42-2.4c.08-.48-.64-.68-.72-.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M36.76,65.49l-.95,2.05c-.2.44.44.82.65.38l.95-2c.2-.44-.44-.82-.65-.38Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M37.13,65.49,36,67.8c-.21.43.44.81.65.38l1.16-2.31c.21-.43-.43-.81-.65-.38Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M37.33,65.5l-1,2.22c-.2.43.45.81.64.37l1-2.21c.19-.44-.46-.82-.65-.38Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M37.21,66.29l-.79,1.51c-.23.43.42.81.65.38l.79-1.51c.23-.43-.42-.81-.65-.38Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M37.73,65.42a7.12,7.12,0,0,0-1.34,2.48.37.37,0,0,0,.72.19A6.09,6.09,0,0,1,38.26,66c.31-.37-.22-.9-.53-.53Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M37.6,65.86,36.5,67.8c-.23.42.41.8.65.38l1.09-1.94c.24-.42-.41-.8-.64-.38Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M37.82,65.24a4.85,4.85,0,0,0-1.08,2.3c-.08.47.64.67.73.2a4.15,4.15,0,0,1,.88-2c.3-.37-.22-.9-.53-.53Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M37.81,65.5l-.89,2.22c-.18.45.55.64.73.2l.88-2.22c.18-.45-.54-.65-.72-.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M37.53,65.76,37,67.27c-.16.45.56.65.72.2L38.25,66c.17-.46-.56-.65-.72-.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M36.51,56.09A10.2,10.2,0,0,0,33.4,59c-.26.37.29.7.59.45l2.85-2.33-.53-.53-3.53,3c-.36.32.17.84.53.53A27.1,27.1,0,0,1,37,57.5l-.38-.65a15.63,15.63,0,0,0-3,2.81.38.38,0,0,0,.53.53l3.09-2.47c.33-.26-.11-.84-.45-.59a17.57,17.57,0,0,0-2.62,2.4.38.38,0,0,0,.45.59,16.28,16.28,0,0,0,2.9-2L37,57.62a7.22,7.22,0,0,0-.77,1c-.26.41.39.79.65.38a5.17,5.17,0,0,1,.65-.83c.33-.35-.17-.83-.53-.53a15.4,15.4,0,0,1-2.75,1.85l.46.59a17.22,17.22,0,0,1,2.47-2.28l-.46-.59-3.09,2.47.53.53A14.78,14.78,0,0,1,37,57.5c.38-.28,0-.9-.38-.65a28.77,28.77,0,0,0-3.86,2.8l.53.53,3.53-3c.37-.32-.16-.83-.53-.53l-2.85,2.33.59.45a9.19,9.19,0,0,1,2.84-2.64c.41-.25,0-.9-.38-.65Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M35.85,57,34.1,58.52c-.31.28.1.82.46.59l1.48-1c.34-.22.13-.84-.28-.68a11.17,11.17,0,0,0-3.14,1.81c-.33.27.1.81.46.59A26.2,26.2,0,0,0,35.76,58c.33-.26-.1-.82-.46-.58a25.44,25.44,0,0,0-3.12,2.47c-.36.33.17.85.53.53A19.86,19.86,0,0,1,35,58.66l-.51-.51-1.12,1.64c-.22.31.2.7.51.51l2.65-1.61L36,58.1l-2,1.57c-.35.28.09.77.45.59l3.11-1.59L37.26,58l-1.79,1.23a.37.37,0,0,0,.29.68,10.41,10.41,0,0,0,2.4-.91l-.38-.65a2.54,2.54,0,0,0-.93.91.38.38,0,0,0,.43.55l1.39-.49-.46-.46-.11.3a.37.37,0,0,0,.36.47,2.52,2.52,0,0,0,1.32-.31c.44-.21.06-.85-.38-.64l-.94.2.36.48.11-.3a.38.38,0,0,0-.46-.46l-1.39.49.42.55.66-.64a.38.38,0,0,0-.38-.65,9.48,9.48,0,0,1-2.22.84l.29.68,1.79-1.22a.38.38,0,0,0-.38-.65l-3.11,1.59.46.59,2-1.57c.34-.27-.1-.81-.45-.59l-2.66,1.61.51.52,1.13-1.65c.21-.3-.21-.71-.51-.51a20.88,20.88,0,0,0-2.41,1.86l.53.53a25,25,0,0,1,3-2.36l-.45-.59A24.24,24.24,0,0,1,32.7,59.2l.45.59A10.33,10.33,0,0,1,36,58.17l-.28-.68-1.49,1,.45.59,1.75-1.56c.36-.32-.18-.85-.53-.53Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M35.67,57.48a5.6,5.6,0,0,0-2.8,1.71.38.38,0,0,0,.46.59l2.17-1.22-.38-.65a11.05,11.05,0,0,0-2.29,2.24c-.23.31.22.71.52.52a5.94,5.94,0,0,0,1.81-1.79.38.38,0,0,0-.59-.46l-1.89,2c-.34.36.16.82.53.53l2-1.55-.53-.53L32.8,60.42l.53.53,1.25-1.16-.53-.53-1,1.2a.38.38,0,0,0,.27.64,1.08,1.08,0,0,0,1-.55l-.69-.28-.18,1.32c-.06.47.66.67.73.2l.17-1.32a.37.37,0,0,0-.68-.29l-.33.17.27.64,1-1.2a.38.38,0,0,0-.53-.53L32.8,60.42c-.36.34.17.83.53.53l1.88-1.54c.38-.31-.16-.82-.53-.53l-2,1.55.53.53,1.89-2-.59-.45A5,5,0,0,1,33,60l.51.51a9.93,9.93,0,0,1,2-2,.38.38,0,0,0-.38-.65L33,59.13l.45.59a4.88,4.88,0,0,1,2.47-1.52.37.37,0,0,0-.2-.72Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M32.91,58.58l-.56,1.21c-.16.36.3.81.59.46l.71-.86L33,59l-.36,1.15c-.12.39.36.59.63.37l.78-.67-.59-.45a3.79,3.79,0,0,0-.37,1.24c0,.3.34.45.57.33l.42-.23-.57-.33a4.44,4.44,0,0,0,.58,1.88.37.37,0,0,0,.64-.38,3.57,3.57,0,0,1-.47-1.5.38.38,0,0,0-.56-.32l-.42.23.56.32a2.61,2.61,0,0,1,.27-.86.38.38,0,0,0-.59-.46l-.78.67.62.36.36-1.15a.38.38,0,0,0-.63-.37l-.71.86.59.45L33.56,59c.2-.44-.45-.82-.65-.38Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M32.61,59.74l1.58,2.59c.26.41.91,0,.65-.38l-1.58-2.59c-.26-.41-.9,0-.65.38Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M33,59.57a8.06,8.06,0,0,0,1.17,3.1c.26.41.91,0,.65-.38a7.62,7.62,0,0,1-1.1-2.92c-.08-.47-.8-.27-.72.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M32.65,60.12l1.25,2.81a.38.38,0,0,0,.7-.19,3,3,0,0,0-.68-1.53c-.37-.5-1.29-1.57-.35-2,.44-.21.06-.85-.38-.65A1.42,1.42,0,0,0,32.44,60c.13,1.07,1.29,1.65,1.41,2.71l.7-.19L33.3,59.74c-.2-.44-.85-.06-.65.38Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M33.11,59.55a6.47,6.47,0,0,1,2.32-1.68c.44-.18.24-.91-.2-.72A7.19,7.19,0,0,0,32.58,59c-.32.36.2.89.53.53Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M32.58,59l-.44.8c-.23.42.42.8.65.38l.44-.81a.37.37,0,0,0-.65-.37Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M35.14,58.17a7.81,7.81,0,0,0-2.17,2,.38.38,0,0,0,.43.55,4.72,4.72,0,0,0,2-1.55l-.69-.29-.6,2.4a.37.37,0,0,0,.72.2l.61-2.4a.38.38,0,0,0-.69-.29A3.78,3.78,0,0,1,33.2,60l.42.55a6.86,6.86,0,0,1,1.9-1.74c.4-.25,0-.9-.38-.64Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M12.17,40c-.23,3.35,3.47,4.25,6.08,3.66.4-.09.31-.6,0-.73-.57-.23-.32-1.09-1.19-1-.67.1-1.11.53-1.86.46a2.45,2.45,0,0,1-2-1.59c-.17-.36-.69-.15-.7.19A2.69,2.69,0,0,0,14,43.58a4.15,4.15,0,0,0,3.67-.32.39.39,0,0,0,.07-.59.91.91,0,0,0-1-.31.38.38,0,0,0-.22.55,9.41,9.41,0,0,0,.84,1.31l.32-.56c-2,.06-4.91-.44-4.92-3a.38.38,0,0,0-.75,0c0,3,3.2,3.87,5.67,3.79.25,0,.5-.33.32-.57a9.35,9.35,0,0,1-.83-1.31l-.23.55.3.12.08-.59c-1.5.75-4.2.74-4.09-1.59l-.7.19a3.21,3.21,0,0,0,3,2c.5,0,1.48-.56,1.85-.3s.29.58.71.76v-.73c-2.15.49-5.33-.07-5.13-2.93,0-.48-.72-.48-.75,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M23.42,45.49a6.58,6.58,0,0,0,4.39-1.78.38.38,0,0,0-.17-.63l-1.19-.32a.37.37,0,0,0-.2.72l1.19.33-.16-.63a5.77,5.77,0,0,1-3.86,1.56c-.48,0-.48.77,0,.75Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M23.07,45.55a10.55,10.55,0,0,0,2.68-.42,4.27,4.27,0,0,0,2.1-1,.77.77,0,0,0,0-1c-.5-.57-1.27-.18-1.89-.2s-.49.73,0,.75c.25,0,1-.21,1.06.19,0,.11-1.09.46-1.28.52a9.79,9.79,0,0,1-2.63.44c-.48,0-.49.77,0,.75Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M22.35,45.82a27.41,27.41,0,0,0,3.95-.42c.68-.12,1.91-.17,2.41-.74a.87.87,0,0,0,.15-1.07c-.25-.39-.39-.17-.72-.4a2,2,0,0,0-.43,0,1.16,1.16,0,0,1-.15-1.79l-.69-.29c-.32.86.13,1.45,1,1.44l-.19-.7a1.73,1.73,0,0,0-.81.6.38.38,0,0,0,.37.63,2.88,2.88,0,0,0,1.37-.66c.37-.31-.16-.83-.53-.53a4.52,4.52,0,0,0-1,1c-.23.33.21.65.51.51A5.7,5.7,0,0,0,29,42.6l-.53-.53a1.55,1.55,0,0,0-.57.74c-.12.23,0,.6.33.57a2,2,0,0,0,1-.3l-.51-.51-.31.54a.38.38,0,0,0,.43.55l.74-.25L29.07,43l-.07.3a.39.39,0,0,0,.37.48l.42.05-.32-.57a.62.62,0,0,0,.4,1v-.72l-4.14,1.63c-.44.18-.25.9.2.73l4.14-1.64a.37.37,0,0,0,0-.72l.05.13a.38.38,0,0,0-.33-.56L29.37,43l.36.47.06-.3a.38.38,0,0,0-.46-.46l-.74.25.42.55.31-.54a.38.38,0,0,0-.52-.52l-.62.2.32.56L29,42.6c.37-.33-.16-.83-.53-.53a3.64,3.64,0,0,1-1.12.7l.51.51a2.94,2.94,0,0,1,.84-.88l-.53-.53-1,.47.36.62.66-.48c.34-.16.16-.7-.19-.7l-.31-.49c.15-.4-.49-.66-.69-.29-.64,1.19-.71,2,.29,2.83.11.09.47,0,.51.09.31.61-.7.57-1.06.65a25.87,25.87,0,0,1-4.3.5c-.48,0-.48.77,0,.75Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M27.68,42.2l1.1.62a4.16,4.16,0,0,1,.51.28.28.28,0,0,1,.24.24q.12.16-.09.18a3.91,3.91,0,0,1-1.08.48l-1.3.58c-.44.19-.06.84.38.64l1.95-.86c.39-.17.93-.33,1.05-.8a.89.89,0,0,0-.5-.94c-.59-.4-1.26-.72-1.88-1.07a.38.38,0,0,0-.38.65Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M28.39,40.81a15.15,15.15,0,0,0,4.15,1.85.38.38,0,0,0,.2-.73,14.15,14.15,0,0,1-4-1.77c-.41-.26-.79.39-.38.65Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M32,41.74a3.59,3.59,0,0,1-2.19-1.09c-.4-.42-.73-.93-1.38-.85-.47.06-.47.81,0,.75s.75.54,1,.78a4.25,4.25,0,0,0,.76.58,4.33,4.33,0,0,0,1.81.58c.48.06.48-.69,0-.75Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M29.08,35.77c0-.72-.55-1-1.2-1.08a3.17,3.17,0,0,1-2.72-1.47c-.25-.41-.9,0-.64.38A3.77,3.77,0,0,0,26,35c.32.17,2.38.56,2.38.77a.38.38,0,0,0,.75,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M25.8,35.29l-.12-.42-.55.43a13.11,13.11,0,0,1,4.33,3.64c.93,1.14,2,2.07,3.52,1.93.48,0,.48-.8,0-.75-2.06.18-3-1.94-4.26-3.2a12.22,12.22,0,0,0-3.21-2.27.38.38,0,0,0-.55.42l.11.42a.38.38,0,0,0,.73-.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M31,40.22a16.69,16.69,0,0,0,4.34,1.51c.47.1.67-.62.2-.72a15.79,15.79,0,0,1-4.16-1.44c-.43-.22-.81.43-.38.65Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M34.53,40.82l-1.66-.6c-.42-.15-.64.46-.29.68a8.34,8.34,0,0,0,3.52,1.23v-.75l-3-.28v.75a34.91,34.91,0,0,1,4.33.33l.1-.74-2.36.06a.38.38,0,0,0-.1.74,8.32,8.32,0,0,0,2.81.36.37.37,0,0,0,.1-.73,5.9,5.9,0,0,0-3.2-.14.39.39,0,0,0,0,.73,8.58,8.58,0,0,0,3.11.16.38.38,0,0,0,0-.75l-1.53,0v.75h.39a.38.38,0,0,0,0-.75h-.39a.38.38,0,0,0,0,.75l1.53,0v-.75A7.94,7.94,0,0,1,35,41.73v.73a5.13,5.13,0,0,1,2.8.13l.1-.74a7.94,7.94,0,0,1-2.61-.34l-.1.74,2.36-.06c.4,0,.53-.67.1-.73a36.23,36.23,0,0,0-4.53-.36c-.49,0-.48.7,0,.75l3,.28c.49,0,.47-.69,0-.75A7.52,7.52,0,0,1,33,40.25l-.29.69,1.66.6c.46.17.65-.55.2-.72Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M34.41,40l.75-1.09c.24-.35-.3-.77-.59-.45l-.73.8a.38.38,0,0,0,.36.63l2-.55-.37-.62-.91.9a.38.38,0,0,0,.26.64A5,5,0,0,0,36.81,40l-.36-.63-.65.52c-.27.21,0,.63.26.64a3.6,3.6,0,0,0,1.13-.17l-.2-.72a1.62,1.62,0,0,0-.9.66c-.21.29.14.61.43.55l1.2-.24-.29-.68-.56.37c-.3.2-.21.72.18.7a3.1,3.1,0,0,0,1.17-.24l-.36-.63-.56.53a.38.38,0,0,0,.27.64A4.54,4.54,0,0,0,39,41.11l-.29-.68-.59.3c-.41.21-.1.75.29.69l1-.16-.29-.69-.43.23c-.35.18-.16.67.19.7l1.54.11c.49,0,.48-.72,0-.75l-1.54-.11.19.7.43-.23c.41-.21.1-.74-.29-.68l-1,.15.29.69.59-.31c.38-.19.11-.78-.29-.68a2.88,2.88,0,0,1-1.27.11l.26.64.56-.53c.25-.24,0-.77-.37-.63a1.9,1.9,0,0,1-1,.22l.19.7.57-.37a.38.38,0,0,0-.29-.69l-1.2.24.42.55.45-.32c.45-.15.27-.86-.2-.72a2,2,0,0,1-.93.14l.27.64.65-.52c.29-.23,0-.76-.37-.63a3.92,3.92,0,0,1-1.42.31l.27.64.91-.9a.38.38,0,0,0-.36-.63l-2,.55.37.62.73-.8-.59-.46-.75,1.09c-.27.39.38.77.65.38Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M39.57,41.25v.18a.38.38,0,0,0,.75,0v-.18a.38.38,0,0,0-.75,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M41.81,44.72a2.33,2.33,0,0,1,.86,1.51c.06.47.81.47.75,0a3.08,3.08,0,0,0-1.08-2c-.37-.31-.9.22-.53.53Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M45.32,48.67a4.2,4.2,0,0,0-4.93.85.38.38,0,0,0,.53.53,3.42,3.42,0,0,1,4-.73c.44.21.82-.43.38-.65Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M36.92,45.81,36.5,46c-.38.17-.1.85.29.68l1.28-.53-.29-.69-1.62,1.19c-.32.24-.15.83.29.69l1.72-.56-.37-.62L36.73,47c-.29.23,0,.74.37.62l1.19-.41-.36-.62-1,.93a.38.38,0,0,0,.36.63l1.09-.35L38,47.21l-.6.58c-.25.25,0,.77.37.63l.79-.3-.36-.63-.45.51a.38.38,0,0,0,.27.64c.62,0,.81.3,1.4-.06L39,48l-.18.15.63.37.17-.76a.38.38,0,0,0-.36-.48l-.81.07.19.7.9-.48c.39-.2.12-.77-.29-.68l-.73.16.2.72.78-.29c.44-.16.27-.86-.2-.72l-1,.3.29.68,1.16-.65a.38.38,0,0,0-.19-.7,3.87,3.87,0,0,0-1.47.27l.29.69.71-.43a.38.38,0,0,0-.19-.7l-1.12.06L38,47l1.41-.69a.38.38,0,0,0-.19-.7,6.68,6.68,0,0,0-1.91.47c-.43.19-.26.9.2.73l1.73-.64c.44-.17.26-.87-.2-.73L37.19,46l.29.69,1.11-.57c.39-.2.11-.78-.29-.69a8.37,8.37,0,0,0-2,.79l.37.64.41-.23a.38.38,0,0,0-.38-.65l-1.18.65a.37.37,0,0,0,.29.68l1-.31-.28-.68-1,.63a.38.38,0,0,0,.38.65l.54-.27L36,46.68l-.93.62a.38.38,0,0,0,.19.7,5.06,5.06,0,0,0,1.4-.16l-.19-.72-.59.19a.38.38,0,0,0,0,.73l1.47.37.1-.73-1.37,0c-.4,0-.53.64-.1.74l2,.42c.47.1.67-.61.2-.72l-.94-.23-.2.72c1.35.26,4.39,1.52,3.91-1a.38.38,0,0,0-.68-.09l-.33.72.7.19v-.91a.38.38,0,0,0-.74-.1l-.29.83.62-.16c-.43-.53-.4-1,.09-1.36.33-.27-.09-.79-.46-.58l-.43.24c-.43.24,0,.84.38.65a4.42,4.42,0,0,0,1-.66l-.53-.53-.47.56a.38.38,0,0,0,.45.59l.8-.43L40.6,46l-1,.87a.37.37,0,0,0,.36.62,2.55,2.55,0,0,0,1.16-.64c.31-.28-.1-.84-.45-.59l-.75.55c-.31.23-.14.85.29.69a4.13,4.13,0,0,0,1.18-.65.38.38,0,0,0-.19-.7,3.62,3.62,0,0,0-1.22.15l.29.69.79-.47a.38.38,0,0,0-.28-.69L39,46.35l.28.68.85-.45a.37.37,0,0,0-.29-.68l-1.12.29.2.73,1.93-.68a.38.38,0,0,0-.2-.73L38.12,46c-.47.1-.27.82.2.72l2.24-.43a.38.38,0,0,0-.1-.74l-2.69.17.1.73a7.93,7.93,0,0,1,1.61-.33v-.75a28.08,28.08,0,0,0-4.61.92.37.37,0,0,0,.2.72,28.71,28.71,0,0,1,4.41-.89c.47,0,.49-.79,0-.75a8.66,8.66,0,0,0-1.81.36c-.39.12-.34.76.1.74l2.69-.17-.1-.74L38.12,46l.2.72,2.57-.5-.2-.73-1.93.68a.38.38,0,0,0,.2.73l1.12-.3-.29-.69-.84.46a.37.37,0,0,0,.28.68L41,46.59l-.29-.68-.8.47a.38.38,0,0,0,.29.69,1.88,1.88,0,0,1,1-.13L41,46.25a2.54,2.54,0,0,1-1,.56l.29.69.75-.55-.46-.59-.83.45.37.63,1-.87c.32-.29-.09-.78-.46-.59l-.8.43.46.59.47-.56a.38.38,0,0,0-.53-.53,2.77,2.77,0,0,1-.9.54l.38.65.43-.25-.45-.59a1.6,1.6,0,0,0-.09,2.42.38.38,0,0,0,.63-.17l.29-.84-.73-.09v.91c0,.34.54.54.7.19l.32-.72-.68-.09c.19,1-1,.45-1.38.37l-1.61-.31c-.47-.09-.68.61-.2.72l.94.23.2-.72-2-.43-.1.74,1.37,0a.38.38,0,0,0,.1-.74l-1.47-.38V48l.58-.2a.37.37,0,0,0-.19-.72,2.93,2.93,0,0,1-1.21.13l.19.69.92-.62a.37.37,0,0,0-.37-.64l-.55.26.38.65,1-.64c.35-.22.14-.82-.28-.68l-1,.31.29.68L37,46.62,36.65,46l-.4.24a.37.37,0,0,0,.37.64,7.62,7.62,0,0,1,1.88-.7l-.29-.69L37.1,46a.38.38,0,0,0,.29.69l1.82-.58-.2-.73-1.73.64.2.73a5.92,5.92,0,0,1,1.71-.45l-.19-.7-1.41.7a.37.37,0,0,0,.19.69L38.9,47l-.19-.7-.71.43c-.34.21-.12.85.29.69a3.23,3.23,0,0,1,1.27-.25l-.19-.7-1.16.66a.37.37,0,0,0,.29.68l1-.3-.2-.72-.78.29a.37.37,0,0,0,.2.72l.73-.16-.28-.69-.91.48a.38.38,0,0,0,.19.7l.81-.07-.36-.47-.18.76a.38.38,0,0,0,.63.36l.18-.15c.33-.28-.09-.81-.45-.59,0,0-1,0-1,0l.26.64.45-.51c.23-.25,0-.76-.36-.62l-.8.3.36.62.6-.58a.38.38,0,0,0-.36-.63l-1.08.35.36.63,1-.94a.38.38,0,0,0-.37-.63l-1.19.41.36.63,1.07-.87c.29-.24,0-.74-.36-.63l-1.72.56.29.68,1.61-1.19c.31-.23.14-.86-.28-.69L36.59,46l.29.68.42-.18c.44-.2.05-.84-.38-.65Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M35.16,47.29l5.2-1.11-.2-.72-4,1.25a.38.38,0,0,0,.2.73,19.89,19.89,0,0,0,3-.76l-.2-.72a24.38,24.38,0,0,0-3,1.35c-.36.2-.11.84.29.69l3.3-1.24-.29-.68L36.3,47.49c-.39.17-.12.81.29.68L40.06,47l-.29-.69-2.55,1.33c-.37.2-.11.84.29.69l2.92-1.1-.29-.69-2.49,1.24c-.38.18-.11.84.28.68l2.55-1-.28-.69-1.91,1c-.36.2-.11.84.29.68l1.87-.75-.29-.68-1.27.8c-.34.22-.13.85.29.69l1.31-.52-.29-.68-1,.57a.37.37,0,0,0,.29.68l.77-.22-.2-.73a1.42,1.42,0,0,0-.94.95c-.08.26.2.57.46.47,1.53-.59,1.17-2.19.61-3.38a.35.35,0,0,0-.32-.18,30.84,30.84,0,0,0-3.85.21,1.7,1.7,0,0,0-1.52,1.31,1.31,1.31,0,0,0,1,1.34,17.23,17.23,0,0,0,3.94.62c.37.05.71-.49.28-.68a14.57,14.57,0,0,0-4.44-1.26v.75l1.18,0a.38.38,0,0,0,0-.75L36,47a.37.37,0,0,0-.38.64,1.19,1.19,0,0,0,.8.22v-.75l-1.18,0c-.49,0-.47.7,0,.75A13.44,13.44,0,0,1,39.35,49l.28-.68L37.26,48c-.35-.05-.71-.07-1-.15a2.08,2.08,0,0,1-.65-.22c-.1-.72.1-1.08.62-1.09a9.74,9.74,0,0,1,2.36-.16c.31,0,.81-.14,1.09,0,.63.33.44,1.78-.19,2l.46.46.41-.42c.44-.17.27-.86-.2-.73l-.77.23.29.69.95-.58c.35-.21.12-.84-.29-.68L39,47.84l.29.69,1.27-.8c.34-.22.12-.86-.29-.69l-1.87.75.29.69,1.9-1c.37-.2.12-.85-.28-.69l-2.56,1,.29.68,2.5-1.23c.38-.19.11-.84-.29-.69l-2.92,1.11.29.68L40.15,47a.38.38,0,0,0-.29-.69l-3.47,1.14.29.68,3.06-1.41c.38-.17.11-.83-.29-.68l-3.3,1.23.29.69a23,23,0,0,1,2.87-1.28c.45-.16.27-.88-.2-.72a21.16,21.16,0,0,1-3,.75l.2.73,4-1.26a.37.37,0,0,0-.2-.72L35,46.57c-.47.1-.27.82.2.72Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M36.84,46.31l2.5-.35-.42-.17A3.42,3.42,0,0,0,40,47c.4.27.78-.38.38-.64a2.67,2.67,0,0,1-.85-.92.42.42,0,0,0-.43-.17l-2.5.35c-.48.06-.28.79.2.72Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M38.69,46.23a5,5,0,0,1,1.69.76c.4.28.77-.37.38-.65a5.52,5.52,0,0,0-1.87-.83c-.47-.11-.67.61-.2.72Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M39.41,46.49a5.52,5.52,0,0,0,2.05.38.38.38,0,0,0,0-.75,5.11,5.11,0,0,1-1.85-.35c-.45-.18-.65.55-.2.72Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M40.3,46.93a2.89,2.89,0,0,0,1.62-.15c.44-.18.25-.9-.2-.72a2.21,2.21,0,0,1-1.22.15c-.48-.08-.68.64-.2.72Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M40.4,46.22c.15.05,0,0,0,0a.39.39,0,0,0-.51.14l0,0a.39.39,0,0,0,.22.56,2.36,2.36,0,0,0,1.89-.19c.43-.21,0-.86-.38-.65a1.59,1.59,0,0,1-1.31.11l.23.55,0-.05-.52.13a1.79,1.79,0,0,0,.24.12c.45.17.64-.55.19-.72Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M40.48,47.14a2.24,2.24,0,0,0,1.68-.66c.35-.33-.18-.87-.53-.53a1.41,1.41,0,0,1-1.15.44c-.48,0-.48.73,0,.75Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M40.26,47.14a1.54,1.54,0,0,0,2.23-1.53c-.05-.47-.8-.48-.75,0a.79.79,0,0,1-1.1.88c-.44-.19-.82.45-.38.65Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M41.9,47.28a2.13,2.13,0,0,0,.45-2,.37.37,0,0,0-.72.2,1.35,1.35,0,0,1-.26,1.25c-.31.37.21.9.53.53Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M42.22,46.75a1.39,1.39,0,0,0-.91-1.83.37.37,0,0,0-.2.72.66.66,0,0,1,.39.91c-.18.44.54.64.72.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M41.9,47a.38.38,0,0,0,0-.75.38.38,0,0,0,0,.75Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M42,46l-1.3-1.47c-.32-.36-.85.17-.53.53l1.3,1.47c.32.36.85-.17.53-.53Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M41.92,46.39a2.72,2.72,0,0,0-2.41.64c-.36.32.17.85.53.53a1.94,1.94,0,0,1,1.68-.45c.47.1.67-.62.2-.72Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M41.73,47.15,44,47.08c.48,0,.48-.77,0-.75l-2.31.07a.38.38,0,0,0,0,.75Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M41.73,47.38l1.51.09c.48,0,.48-.73,0-.75l-1.51-.09c-.48,0-.48.73,0,.75Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M41.54,47.2l2.58.54c.47.09.67-.63.2-.73l-2.58-.53c-.47-.1-.67.62-.2.72Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M41.27,46.94l2.4.53c.47.1.67-.62.2-.72l-2.4-.53c-.47-.1-.67.62-.2.72Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M40.92,47l2.22.62a.37.37,0,0,0,.2-.72l-2.22-.62a.37.37,0,0,0-.2.72Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M40.47,47.22a10.13,10.13,0,0,0,3.66.61.38.38,0,0,0,0-.75,9.27,9.27,0,0,1-3.46-.59c-.46-.16-.65.56-.2.73Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M41.46,47.48a11.3,11.3,0,0,1,2.83.45.38.38,0,0,0,.2-.73,12.43,12.43,0,0,0-3-.47c-.48,0-.48.73,0,.75Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M42.73,53.88a35.43,35.43,0,0,0-19.57-4.79c-.48,0-.49.77,0,.75a34.68,34.68,0,0,1,19.19,4.68.37.37,0,0,0,.38-.64Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M41,54.09a34.06,34.06,0,0,0-13.08-2.44.38.38,0,0,0,0,.75,33.6,33.6,0,0,1,12.88,2.41c.45.18.65-.55.2-.72Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M39,53.44a18.14,18.14,0,0,0-9.45,1.83c-.44.21-.06.86.37.65A17.38,17.38,0,0,1,39,54.19c.48,0,.48-.72,0-.75Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M26.61,52.38c-2-.39-3.91-.66-5.59.69-1.05.83-1.74,2-2.78,2.91a10.49,10.49,0,0,1-5.74,2.37c-.48.06-.48.81,0,.75a11.47,11.47,0,0,0,5.86-2.23,16.94,16.94,0,0,0,2.08-2.07c1.74-1.86,3.48-2.19,6-1.69.48.09.68-.63.2-.73Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M15.18,58.2a10.39,10.39,0,0,0,4.36-1.76c2-1.39,3.9-3.28,6.57-2.45a.37.37,0,0,0,.2-.72,5.53,5.53,0,0,0-4.78.82C19.29,55.48,17.7,57,15,57.47c-.48.08-.28.81.2.73Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M25.72,52.43c-2,.51-4.37.47-6,1.9A9.68,9.68,0,0,0,18.41,56a7,7,0,0,1-5.47,3c-.48,0-.48.77,0,.75a7.48,7.48,0,0,0,5.42-2.48c1-1.14,1.56-2.42,3-3.1s3.05-.69,4.53-1.07a.37.37,0,0,0-.2-.72Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M10.53,45a3.8,3.8,0,0,0,3.6,0c.43-.23,0-.88-.38-.65a3,3,0,0,1-2.84,0c-.43-.22-.81.43-.38.65Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M10.8,45.3c1.75.16,3.63.14,4.72-1.45.27-.4-.38-.78-.65-.38-.91,1.34-2.64,1.21-4.07,1.08-.48,0-.47.71,0,.75Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M10.62,45.32a5.32,5.32,0,0,0,3.5-.1c.45-.17.26-.9-.2-.73a4.65,4.65,0,0,1-3.1.11.37.37,0,0,0-.2.72Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M10.87,45.32a5.73,5.73,0,0,0,4.21.2c.45-.15.26-.88-.2-.72a5.05,5.05,0,0,1-3.63-.12c-.44-.19-.82.45-.38.64Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M10.71,45.85a5.47,5.47,0,0,0,3.69-.67.38.38,0,0,0-.38-.65,4.64,4.64,0,0,1-3.11.6c-.48-.07-.68.65-.2.72Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M11.05,45.28a6.78,6.78,0,0,0,3.76-.21c.46-.15.26-.88-.2-.72a6.1,6.1,0,0,1-3.36.21c-.47-.11-.67.61-.2.72Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M10.89,45.53a8.58,8.58,0,0,0,3.85-.59c.44-.18.25-.91-.2-.73a8.13,8.13,0,0,1-3.65.57c-.48,0-.48.71,0,.75Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M11.69,45.71a11.43,11.43,0,0,0,3.67-.6c.45-.15.26-.88-.2-.72a11.07,11.07,0,0,1-3.47.57.38.38,0,0,0,0,.75Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M11,45.44a9.22,9.22,0,0,0,4.1-.54c.45-.16.26-.89-.2-.72a8.77,8.77,0,0,1-3.9.51c-.48,0-.48.71,0,.75Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M11.69,45.63a10.53,10.53,0,0,0,4.45-1c.44-.21.06-.86-.37-.65a9.45,9.45,0,0,1-4.08.94.38.38,0,0,0,0,.75Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M12.23,45.17a8.31,8.31,0,0,0,4.64-.91c.43-.22.05-.86-.38-.64a7.67,7.67,0,0,1-4.26.8c-.48-.05-.48.7,0,.75Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M12.49,45.46a7.79,7.79,0,0,0,4-1.48c.38-.29,0-.94-.38-.65a7,7,0,0,1-3.64,1.38c-.47,0-.48.79,0,.75Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M12.77,44.81a24.43,24.43,0,0,0,4.09-1.64c.43-.22.05-.87-.38-.65a24,24,0,0,1-3.91,1.57.37.37,0,0,0,.2.72Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M15.07,75.89a13.58,13.58,0,0,0,9.32-2.78c.37-.29,0-.94-.38-.65a12.91,12.91,0,0,1-8.94,2.68c-.48,0-.48.72,0,.75Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M15.6,75.42a11.6,11.6,0,0,0,7.63-2c.4-.27,0-.92-.38-.65a10.92,10.92,0,0,1-7.25,1.88c-.48,0-.48.71,0,.75Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M16.5,75.6a10.78,10.78,0,0,0,7.06-1.81c.4-.27,0-.92-.38-.65a10.09,10.09,0,0,1-6.68,1.71c-.48,0-.48.7,0,.75Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M14.89,75.65a21.49,21.49,0,0,0,8.49-2c.44-.2.06-.85-.38-.65a20.64,20.64,0,0,1-8.11,1.91.38.38,0,0,0,0,.75Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M18.72,75.52a19.24,19.24,0,0,0,5.93-2.3.38.38,0,0,0-.38-.65,18.41,18.41,0,0,1-5.75,2.22c-.48.1-.28.82.2.73Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M32.08,66.3a6,6,0,0,0-.76,1.76.38.38,0,0,0,.55.42,3.41,3.41,0,0,0,1.21-.87l-.53-.53-1.19,1.45a.38.38,0,0,0,.45.59l1.55-.75-.51-.51c-.34.6-.76.63-.58,1.34a.39.39,0,0,0,.37.27c.48,0,.59-.3,1.07-.37l-.42-.55-.5.7c-.2.29.14.61.43.55a1.89,1.89,0,0,0,1.14-.63l-.63-.36-.43,1.93c-.06.28.27.63.55.42a5.32,5.32,0,0,0,1.45-1.61l-.65-.38c-.56,1.25.8,2.47,1.64,1.17l-.69-.19c0,1.18,1.52,2.13,1.67.58h-.75a.91.91,0,1,0,1.82.19h-.73c.31,1.26,1.16.21,1.92.41a.37.37,0,0,0,.2-.72c-.16,0-1.42,0-1.39.11a.38.38,0,0,0-.73,0h-.34a.38.38,0,0,0-.75,0l-.17-.58a.38.38,0,0,0-.7-.19l-.35-.41c.19-.43-.4-.81-.65-.38a3.39,3.39,0,0,1-1.18,1.34l.55.43L34.45,69a.38.38,0,0,0-.62-.37l-.81.44.42.55.5-.7c.21-.3-.14-.6-.43-.56.15,0-.87.17-.6.26s.47-.18.59-.39a.38.38,0,0,0-.51-.52l-1.56.75.46.59,1.19-1.45c.31-.36-.19-.89-.53-.53a2.18,2.18,0,0,1-1,.75l.55.43a5.29,5.29,0,0,1,.68-1.58c.26-.41-.39-.78-.65-.38Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M31.12,68.08l.55,2.41c.09.38.61.32.73,0l.36-1-.73-.1a2.76,2.76,0,0,0,.2,1.39.38.38,0,0,0,.55.22,1.05,1.05,0,0,0,.56-.61h-.65a2.31,2.31,0,0,0,.66,1,.38.38,0,0,0,.53,0s1,.33,1.57-.31l-.63-.16c.37.89.69.6,1.44.87-.53-.19,2.39,1.15,2.07.69a.38.38,0,0,0,.65,0c.49-.76,1.27-.13,1.88-1.08l-.7-.19c.18,1.5.93,1.08,1.83.64.16-.08.57.09.78,0s.41-.44.63-.55a3.87,3.87,0,0,0,1.17-.73c.33-.35-.2-.88-.53-.53l-.75.18a.37.37,0,0,0-.46.26l-1,.48a.38.38,0,0,0-.55.22l-.38.07a.38.38,0,0,0-.7-.19l-.73.15a.38.38,0,0,0-.59.07l-.56.86H39c-.29-.43-.26-.46-.56-.67a5.65,5.65,0,0,0-1.59-.3.38.38,0,0,0-.55-.23l-.73-.18c-.1-.23-.43-.41-.63-.17l-.62,0a.38.38,0,0,0-.59-.08L33.34,70a.38.38,0,0,0-.65,0l.09-.63a.38.38,0,0,0-.74-.1l-.37,1h.73l-.56-2.41c-.11-.47-.83-.27-.72.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M44.26,65.77A36.6,36.6,0,0,1,42,69.58c-.27.4.38.77.65.37a35.46,35.46,0,0,0,2.25-3.8c.22-.43-.42-.81-.65-.38Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M43.41,66.4a8.59,8.59,0,0,1-1.75,5.13c-.29.39.36.76.65.38a9.29,9.29,0,0,0,1.85-5.51.38.38,0,0,0-.75,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M43.38,68.44l-1.69,3c-.23.42.41.8.65.38l1.69-3c.23-.42-.41-.8-.65-.38Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M42.71,69.42,41,71.29c-.32.35.2.88.53.53L43.24,70c.32-.36-.21-.89-.53-.53Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M44.21,49.49a2.33,2.33,0,0,1,.87.34l.29-.68a7.26,7.26,0,0,0-3.89.38c-.45.18-.26.9.19.73a6.54,6.54,0,0,1,3.5-.39.38.38,0,0,0,.29-.69,2.81,2.81,0,0,0-1.05-.41c-.48-.08-.68.64-.2.72Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M43.68,49.18l.85,0c.42,0,.52-.66.1-.73a3.4,3.4,0,0,0-2.14,0A1.58,1.58,0,0,0,41.55,50a.38.38,0,0,0,.75,0c0-1.07,1.45-.88,2.13-.75l.1-.74-.85,0c-.48,0-.48.72,0,.75Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M45.9,47.25a.88.88,0,0,0-.86,0,.37.37,0,0,0-.14.51l.61.85c.19.27.73.22.7-.19A4.54,4.54,0,0,0,44,44.84c-.41-.25-.79.4-.37.65a3.76,3.76,0,0,1,1.79,2.93l.7-.19-.61-.85-.13.52h.1c.44.2.82-.44.38-.65Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M44.58,45.42l-.21-.08c-.39-.14-.58.37-.37.63l1.3,1.56c.31.38.83-.16.53-.53l-.19-.24c-.31-.38-.84.16-.54.53l.2.24.53-.53-1.3-1.56-.36.62.21.08c.45.17.65-.55.2-.72Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M44.48,46.16a.38.38,0,0,0,0-.75.38.38,0,0,0,0,.75Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M44.22,46.05l.62,1.52c.18.44.91.24.72-.2l-.62-1.51c-.18-.44-.91-.25-.72.19Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M44.56,47.12l.27.71c.17.45.89.26.72-.19l-.26-.72c-.17-.44-.9-.25-.73.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M44.56,47.12l.27.8c.15.46.88.26.72-.2l-.26-.8c-.15-.45-.88-.26-.73.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M44.42,47.57l.36.53c.27.4.92,0,.65-.38l-.36-.53c-.26-.4-.91,0-.65.38Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M45.3,47.47a2.49,2.49,0,0,0-.23-1.26c-.19-.44-.84-.06-.65.38a1.67,1.67,0,0,1,.13.88c0,.48.71.48.75,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M45.29,47.38a1.86,1.86,0,0,0-.62-1.26c-.36-.32-.89.21-.53.53a1.08,1.08,0,0,1,.4.73c.05.47.81.48.75,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M45.19,47.1l-.66-2.41a.38.38,0,0,0-.73.2l.67,2.41a.37.37,0,0,0,.72-.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M46.88,50.67l2.4,2.22c.36.33.89-.2.53-.53l-2.4-2.22c-.35-.33-.88.2-.53.53Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M47.55,50.76a8.78,8.78,0,0,0,1.53,2.33c.32.36.85-.17.53-.53a8.27,8.27,0,0,1-1.42-2.18c-.2-.43-.84-.05-.64.38Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M48.38,51.91c.31.22.78.56.85,1s-.27.67-.55.88a3.85,3.85,0,0,0-1,1c-.26.41.39.79.65.38.42-.7,1.38-.91,1.64-1.73s-.49-1.65-1.16-2.14c-.39-.28-.77.37-.38.65Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M48.13,51.88a16.16,16.16,0,0,0-3.11,0,.38.38,0,0,0,0,.75l3.44.22c.48,0,.47-.7,0-.75a11.27,11.27,0,0,0-4.13.35c-.39.1-.33.78.1.73l3.77-.36v-.75a10.33,10.33,0,0,0-3.26,1c-.32.16-.18.75.19.7a30.24,30.24,0,0,0,4.32-.84.37.37,0,0,0-.19-.72,11.46,11.46,0,0,0-2.73,1c-.39.19-.11.78.29.68l2.55-.64-.2-.73a5.79,5.79,0,0,0-2,1c-.28.22,0,.62.27.64a4.54,4.54,0,0,0,2.23-.45c.4-.18.11-.78-.29-.68a4.81,4.81,0,0,0-1.25.5c-.3.18-.19.74.19.7l.65-.07-.26-.64-.63.6c-.26.24,0,.77.36.63l.68-.28-.29-.68L47,54.65l.51.51.46-.72-.68-.29A9.82,9.82,0,0,1,46,56.38l.63.36a1.93,1.93,0,0,1,.66-1.14l-.59-.45-1.84,2.39c-.26.34.31.77.59.45l.88-1-.53-.53-.48.57c-.3.37.22.9.53.53l.48-.57c.3-.37-.2-.9-.53-.53l-.88,1,.59.46,1.84-2.4c.28-.36-.29-.7-.59-.45a2.27,2.27,0,0,0-.85,1.47c-.06.33.37.7.63.37A11.49,11.49,0,0,0,48,54.35c.17-.41-.47-.63-.68-.29l-.46.72c-.22.35.19.66.51.52l1.87-.85c.38-.18.1-.85-.29-.69l-.67.27.36.63.63-.6c.21-.21.06-.68-.27-.64l-.65.07.19.7a4,4,0,0,1,1.07-.43l-.29-.68a3.68,3.68,0,0,1-1.85.34l.26.64a4.69,4.69,0,0,1,1.65-.84.38.38,0,0,0-.2-.73l-2.55.65.29.68a11,11,0,0,1,2.54-.92l-.19-.72a30.45,30.45,0,0,1-4.13.81l.19.7a9.34,9.34,0,0,1,2.88-.88c.47-.06.49-.79,0-.75l-3.77.36.1.74a10.85,10.85,0,0,1,3.93-.32v-.75L45,51.87v.75a16.16,16.16,0,0,1,3.11,0c.48,0,.47-.7,0-.75Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M44.93,52.73a12.33,12.33,0,0,0,2.83-.36.38.38,0,0,0-.1-.74,7,7,0,0,0-3.44,1.13c-.35.22-.14.82.29.68l2.55-.81L46.7,52l-1.59,1.32c-.33.27.09.8.45.59l1.75-1-.45-.59-1.39,1.25a.38.38,0,0,0,.37.63,9.73,9.73,0,0,0,2.44-1.31l-.45-.59-1.55,1.34c-.3.26,0,.72.36.63a5,5,0,0,0,2.09-1.09l-.53-.54-1,.93a.38.38,0,0,0,.37.63,4.7,4.7,0,0,0,1.81-.78L49,52.82l-.93,1a.38.38,0,0,0,.27.64,1.85,1.85,0,0,0,1.28-.38.38.38,0,0,0-.38-.65,2.18,2.18,0,0,0-1,.89.39.39,0,0,0,.33.57h.27c.48,0,.48-.72,0-.75h-.27l.32.56a1.2,1.2,0,0,1,.69-.62l-.38-.65a1,1,0,0,1-.9.28l.26.64.93-1c.27-.3-.08-.84-.45-.58a4.28,4.28,0,0,1-1.63.69l.36.63,1-.92c.35-.34-.17-.85-.53-.54a4.13,4.13,0,0,1-1.76.91l.37.62,1.55-1.34c.31-.28-.11-.85-.46-.59a9,9,0,0,1-2.26,1.24l.36.62,1.39-1.25c.32-.28-.09-.79-.46-.58l-1.74,1,.45.59,1.59-1.32c.29-.24,0-.74-.36-.63l-2.56.81.28.69a6.28,6.28,0,0,1,3.07-1l-.1-.73a11.69,11.69,0,0,1-2.63.33.38.38,0,0,0,0,.75Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M46.17,51.56,44,53.68l.59.45a5.48,5.48,0,0,1,1.7-1.48l-.52-.52-1,1.27c-.26.33.21.65.51.52a10.91,10.91,0,0,0,1.83-1.09l-.45-.59-1.31,1.37c-.24.25,0,.78.36.63a9.61,9.61,0,0,0,2.58-1.53l-.53-.53-1.24,1.26c-.25.25,0,.75.36.62A5.79,5.79,0,0,0,48.88,53l-.53-.53-1.5,1.37a.38.38,0,0,0,.37.62,4.81,4.81,0,0,0,2.2-1.33l-.59-.46-.74,1c-.19.26.07.53.32.56a3,3,0,0,0,2-.38c.42-.23,0-.88-.38-.65a2.33,2.33,0,0,1-1.59.28l.32.57.75-1c.25-.35-.3-.76-.59-.45A4.08,4.08,0,0,1,47,53.72l.36.63L48.88,53c.36-.33-.16-.83-.53-.53a4.88,4.88,0,0,1-1.61.89l.37.63,1.24-1.26c.35-.35-.16-.83-.53-.53a8.25,8.25,0,0,1-2.25,1.33l.37.63,1.31-1.37c.28-.29-.1-.85-.46-.59A10.91,10.91,0,0,1,45,53.27l.51.51,1-1.27c.24-.31-.21-.68-.51-.51a6.2,6.2,0,0,0-2,1.75c-.27.35.29.75.58.46l2.14-2.12c.35-.34-.18-.87-.53-.53Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M48.93,52.33a9.52,9.52,0,0,0-4.17.47l.29.69,1.1-.81c.39-.27,0-.91-.37-.64l-1.55,1a.37.37,0,0,0,.38.64l1.91-1c.44-.23.06-.83-.38-.64a4.16,4.16,0,0,0-1.53,1.1c-.24.26,0,.76.36.63L47,53l-.36-.63-.93,1c-.25.25,0,.76.36.62l2-.76-.37-.63L46.47,53.9a.38.38,0,0,0,.37.63A5.84,5.84,0,0,0,49,53.65a.37.37,0,0,0-.38-.64,3.33,3.33,0,0,0-1.28,1,.38.38,0,0,0,.37.63,4.18,4.18,0,0,0,1.79-1c.37-.32-.16-.82-.53-.53l-1.25,1c-.27.21,0,.64.26.64.5,0,1.09-.07,1.28-.62a.74.74,0,0,0-.4-.95c-.62-.21-1.19.57-1.53.93-.78.85-1.48,1.76-2.18,2.67-.28.36.28.72.58.46l2-1.76-.53-.53L45,57.5l.53.53,1.55-2c.29-.37-.19-.89-.53-.53l-2.06,2.21.59.45a4.83,4.83,0,0,1,1.68-1.56L46.36,56a13.42,13.42,0,0,1-3.19,1.76c-.44.16-.27.86.2.72a19,19,0,0,0,3.09-1.2l-.38-.64L44,57.89c-.34.22-.13.85.29.69l2.29-.88L46.29,57,45,57.91c-.33.22-.14.85.28.68l1.14-.44L46,57.6l-.2.25c-.22.29.15.6.43.55a1.14,1.14,0,0,0,.63-.26l-.52-.51-.1.23a.38.38,0,0,0,.23.55.9.9,0,0,0,.7,0l-.46-.26.11.32a.38.38,0,0,0,.36.27h.59a.38.38,0,0,0,0-.75h-.59l.37.28L47.44,58A.4.4,0,0,0,47,57.7h-.31l.23.55L47,58c.14-.31-.17-.75-.51-.52l-.45.19.42.55.19-.26c.2-.25-.13-.66-.42-.55l-1.14.45.29.69,1.3-.9c.33-.22.13-.84-.29-.68l-2.29.87.29.69,2.08-1.31a.37.37,0,0,0-.38-.64,18.61,18.61,0,0,1-2.91,1.12l.2.72a14.12,14.12,0,0,0,3.37-1.83c.38-.28,0-.89-.38-.65a5.72,5.72,0,0,0-2,1.84c-.24.35.3.76.59.45L47.06,56l-.53-.53L45,57.5c-.29.37.2.91.53.53l2.23-2.56a.37.37,0,0,0-.53-.53l-2,1.76.59.45c.45-.58.9-1.17,1.38-1.73.1-.12,1.32-1.43.81-1.43l.27.64,1.25-1L49,53.09a3.33,3.33,0,0,1-1.46.77l.36.63A3.22,3.22,0,0,1,49,53.65L48.62,53a5.51,5.51,0,0,1-2,.8l.36.62,1.19-1.31c.23-.26,0-.78-.36-.63l-2,.76.37.63.93-1c.25-.25,0-.75-.36-.63l-2,.69.37.63a3.77,3.77,0,0,1,1.38-1L46.14,52l-1.91,1,.38.64,1.54-1L45.78,52l-1.11.8c-.32.23-.14.83.29.68a9.21,9.21,0,0,1,4-.44c.48.05.47-.7,0-.75Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M46.26,55.82l-1.39,1.61a.38.38,0,0,0,.36.63,4.33,4.33,0,0,0,1.91-.87l-.53-.53-1.28,1.15a.38.38,0,0,0,.26.64,1.52,1.52,0,0,0,1.11-.52l-.63-.36-.16.53a.37.37,0,0,0,.36.47,5.9,5.9,0,0,1,1.39.13c.47.11.67-.61.2-.72a6.09,6.09,0,0,0-1.59-.16l.36.47.16-.52a.38.38,0,0,0-.62-.37.81.81,0,0,1-.58.3l.27.64,1.28-1.15c.37-.33-.16-.82-.53-.53a3.66,3.66,0,0,1-1.58.68l.37.62,1.39-1.61c.32-.36-.21-.89-.53-.53Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M45.09,56.08a10.48,10.48,0,0,0-2.33.65.38.38,0,0,0,.1.74.89.89,0,0,0,.67-.16c.39-.22.1-.75-.29-.68l-.71.11.2.72a3,3,0,0,0,1-.66.38.38,0,0,0-.37-.63,2.62,2.62,0,0,1-2.8-.79c-.32-.36-.85.17-.53.53a3.36,3.36,0,0,0,3.53,1l-.36-.63a1.7,1.7,0,0,1-.68.47.37.37,0,0,0,.2.72l.71-.11-.29-.69-.29.06.1.74a10.5,10.5,0,0,1,2.33-.66c.48-.07.28-.79-.2-.72Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M46.34,55.72a4,4,0,0,0-2,1.05l.53.53.59-.69a.38.38,0,0,0-.37-.62,8.64,8.64,0,0,0-2,.73l.51.51.33-.43c.23-.29-.14-.6-.42-.55a4.31,4.31,0,0,0-1.17.37l.51.51L43,56.8a.38.38,0,0,0-.43-.55c-.52.09-1.4.51-1.64-.44a.37.37,0,0,0-.72.2,1.64,1.64,0,0,0,.87,1.16c.58.28,1.1-.09,1.69-.2l-.42-.55-.19.34a.38.38,0,0,0,.52.51,2.48,2.48,0,0,1,1-.3l-.42-.55-.33.43c-.25.33.21.67.51.52a8.16,8.16,0,0,1,1.85-.66l-.36-.63-.59.69c-.3.37.18.87.53.53a3.27,3.27,0,0,1,1.68-.86c.47-.09.27-.82-.2-.72Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M46.12,55.77l-2.27.91.36.63.57-.69a.38.38,0,0,0-.45-.59c-1.66.9-3.2.27-4.73-.61a.38.38,0,0,0-.38.65c1.84,1,3.55,1.65,5.49.61l-.46-.59-.57.69c-.21.25,0,.78.37.63l2.27-.91c.44-.18.25-.91-.2-.73Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M4.53,45.86l-.65,1c-.24.36.28.73.59.45-.57-.69-1-.37-1.39,1-.2.26,0,.78.37.63l1-.37q.27-.17-.27-.21a8.19,8.19,0,0,0-1.81,1.88.38.38,0,0,0,.52.51c1.72-1.1.68-1.76-.08.5a.38.38,0,0,0,.55.42,1.42,1.42,0,0,1-.63,1.43.38.38,0,0,0,.59.46c-1.28,1,.41-2.58-1.06,1.22-.15.39.37.58.63.37-1,.82-.74,4.78-.64,5.8a16.24,16.24,0,0,0,1.7,5.6c.21.43.86,0,.65-.38a14.83,14.83,0,0,1-.68-12c.14-.39-.36-.58-.62-.36l.85-1a.37.37,0,0,0-.53-.53,1.67,1.67,0,0,0,1.05-1.55c.16-.32-.17-.72-.51-.51l.62-1.11c.3-.36-.19-.88-.53-.53.41.24.74,0,1-.78.35-.34-.17-.85-.53-.54-.17.72.15.36,1-1.07a.37.37,0,0,0-.53-.53l.09.53c.27-.41-.38-.78-.64-.38Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M16.69,81.3c9.23,2.89,18.41-.08,25.91-5.79C44,74.45,49,69.2,44.84,74A20.72,20.72,0,0,1,38,79a38.31,38.31,0,0,1-9.84,2.8c-1.73.29-4.32,1.08-6.05.78a1.43,1.43,0,0,1-1.87-.84c-1.6-.91-1.36-1.34.74-1.29,2.58-1.21,6.09-1.45,8.85-2.22,2.94-.81,5.85-1.7,8.76-2.6A40.29,40.29,0,0,0,45,73.53c.94-.48,2.16-2.25,1.44-.73-3,6.29-10.48,8.87-16.94,9.6-2.37.26-8.28.88-10.09-1s2.1.13,2.5-1c.51-1.44-2.06,0-2.57.14s-.34.78.09.73a58,58,0,0,0,7.84-1.4c.47-.12.26-.8-.2-.73a32.42,32.42,0,0,0-7.91,2.33c-.39.16-.11.82.29.68a78,78,0,0,1,8.19-2.34c.47-.11.27-.82-.2-.73l-8,1.59c-.47.1-.27.81.2.73L21.94,81c.41-.08.32-.78-.1-.74a10.15,10.15,0,0,0-3.45.65c-.39.11-.33.76.1.73,1.1-.07,2.41-.88.5-.53-.47.09-.27.8.2.72l16.9-3a.38.38,0,0,0-.1-.74,45.88,45.88,0,0,0-8.76,1.65.38.38,0,0,0,.2.73q6.91-1.29,13.72-3c.4-.09.33-.78-.1-.73-1.21.15-7.82.86-7.67,1.61.12.58,7.75-1.82,8.73-2.09a.38.38,0,0,0-.2-.73c-1.17.27-8.76,1.84-8.54,2.6s7.87-2.11,8.82-2.42A.37.37,0,0,0,42,75a51.85,51.85,0,0,0-10.13,3.12c-.39.17-.11.81.29.69l10.41-3.15a.37.37,0,0,0-.2-.72c-3.19.85-6.54,1.49-9.66,2.59-5.62,2,3.16-.38,4.35-.65.76-.17,3.2-.08,2.63-1.25-.1-.21-4,.79-4.33.86-3.17.68-6.31,1.48-9.43,2.36a.37.37,0,0,0,.2.72c.48-.08,4.2-.42,4.49-.78.61-.79-4.14.26-4.19.28a.37.37,0,0,0,0,.72c4.21.7-4.1,1.25-5.58,1.79a.37.37,0,0,0,.2.72c4.82-.69,11.79-.35,15.84-3.28.33-.23.15-.81-.29-.68-1.46.42-3,.7-4.42,1.13s-4,1.19-1,.56a44.82,44.82,0,0,0,8-2.82c.85-.36,4.64-1.65,4.63-2.37,0,1.11-7.38,4.12-8.52,4.62a.38.38,0,0,0,.19.7,17,17,0,0,0,10.1-4.47.38.38,0,0,0-.46-.59C39,79,31.85,83,24.31,82.66a4.88,4.88,0,0,1-2.46-.31q-2-.41,1.14-.84A37.89,37.89,0,0,1,27.65,80l10.27-3.36A56.29,56.29,0,0,0,44.1,74.5c.7-.33,3.69-1.72,2.68-2.22.89.44-6,5.92-7.05,6.43-3.37,1.63-7.14,2.29-10.79,3-.47.09-.27.81.2.72C36.64,81,44.68,79,48,71.37a.37.37,0,0,0-.64-.38c-2.9,4-9.86,5-14.29,6.43L19.06,82c-.33.11-.38.64,0,.72,6.87,1.48,13.41,0,19.64-3.06.66-.33,4.93-3.22,5.31-3-1-.51-5.35,2.34-6.21,2.5-1.16.48-.88.33.85-.43a32.18,32.18,0,0,0,2.9-1.54,22.24,22.24,0,0,0,3.85-3.13.38.38,0,0,0-.45-.59,68.08,68.08,0,0,1-17.31,6.63c-.4.09-.32.78.1.73,2.08-.22,5.47-1.64,7.3-1.29-2.27-.44-6.06.84-8.35,1.17-1,.14-3.1,0-3.9.56-1.7,1.09,2.09.15,2.61.07a10.66,10.66,0,0,0,4.35-1.47c.29-.19.2-.73-.19-.7-3.12.21,2.33-.63,2.54-.68.48-.11.27-.8-.2-.72s-4.24.44-4.48.79c-.6.82,4.12-.46,3.82-.39,3.43-.85,6.9-1.55,10.38-2.16.48-.08.27-.79-.2-.72a66.61,66.61,0,0,0-12.58,3.24.37.37,0,0,0,.2.72c3.18-.85,6.56-1.46,9.65-2.58,2-.72,3.17-1.28.2-.71a14.89,14.89,0,0,0-4.34,1.31c-2,1.23,2.13-.24,2.53-.34.72-.18,3.43-.7,3.28-1.15s-8.18,2.31-8.81,2.52a.37.37,0,0,0,.2.72c1.1-.34,8.63-2.32,8.52-2.7-.18-.62-7.88,1.86-8.79,2.11a.38.38,0,0,0,.2.73c1.8-.43,3.9-.63,5.65-1.19,5-1.57-.87-.15-1.5,0-1.43.33-2.86.63-4.29.93-1,.21-4.13.93-1.55.86.4,0,4.05-1.32,4-1.33-.31-.27-5.18.91-5.64,1a39,39,0,0,0-5.63,1c-.5.16-4.32,1.52-1.57,1a.37.37,0,0,0-.1-.73c-2.76.18,1.41.13,2.56-.1,5.13-1,0-1.3-1.95,0-1.5,1,.77.23,1.6.1.51-.08,3.24-.4,2.27-1.19s-8,2.31-2,.57a.37.37,0,0,0-.2-.72l-6.38,1.19a.38.38,0,0,0-.09.69c10.2,4.54,27.05,1.92,30.69-10.12.12-.4-.49-.67-.68-.29C44.94,74.55,35.12,75.92,31.41,77c-4.68,1.34-9.4,2.51-14.18,3.44A.38.38,0,0,0,17,81c2.53,4.81,11.73,1.65,15.75.61C39,80,44.63,76.74,47.8,70.93a.37.37,0,0,0-.58-.46C39,78.36,28.5,84.21,16.89,80.57c-.46-.14-.66.58-.2.73Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M51.22,56.1C49.18,57.46,47,59,46,61.34,45,64.07,45.9,67,47,69.5c.15.34.72.17.7-.19A28.21,28.21,0,0,1,48,63.43l-.73-.1L47,66.5a.38.38,0,0,0,.7.18,32.18,32.18,0,0,0,2.18-6.18.37.37,0,0,0-.72-.2L48,64.72c-.1.4.49.69.69.29l2.79-5.57-.68-.29-1.12,4.36c-.1.4.49.67.68.28a22.47,22.47,0,0,0,2.28-7c0-.25-.16-.58-.46-.46a9.3,9.3,0,0,0-5.87,10.59c.06.37.64.34.72,0a20.59,20.59,0,0,1,2.44-6l-.64-.38L46.6,64.46l.65.38a36,36,0,0,0,1.66-4.37c.13-.43-.45-.62-.69-.29a12.88,12.88,0,0,0-1.83,3.6c-.14.4.48.65.68.29a13.08,13.08,0,0,0,1.19-2.87c.12-.4-.5-.69-.68-.29l-1,2.27.68.29a12.65,12.65,0,0,1,.91-3l-.69-.29L47,63a.37.37,0,0,0,.68.29l1.86-3.13-.65-.38-1.18,2.66c-.19.43.41.81.65.38a16.26,16.26,0,0,0,1.43-3.39c.14-.47-.56-.65-.72-.2l-1,2.72c-.16.43.45.61.68.29a13.88,13.88,0,0,0,1.74-3.21l-.72-.2L49,61.48a.37.37,0,0,0,.72.2l1.09-3c.16-.46-.56-.65-.73-.2l-1,2.66c-.14.39.51.67.69.28l1.39-3-.69-.29L50,60.75a.37.37,0,0,0,.72.2l.84-2.52-.73-.2L50.3,60.5a.38.38,0,0,0,.73.2l1.09-2.88-.74-.1a23.84,23.84,0,0,1-4.57,11.67l.65.38c1-2,1.9-4.08,2.7-6.19.16-.41-.48-.65-.68-.29L47.33,67l.69.29A15.12,15.12,0,0,1,49.91,64c.26-.35-.29-.74-.59-.46a10.34,10.34,0,0,0-2.27,3.08l.65.37,1.85-3.91c.2-.44-.44-.82-.65-.38l-1.85,3.92c-.2.43.43.81.65.37a9.74,9.74,0,0,1,2.15-2.91l-.59-.46a16.47,16.47,0,0,0-2,3.53c-.17.4.47.65.68.29l2.14-3.74-.68-.29q-1.17,3.08-2.63,6a.38.38,0,0,0,.65.38,24.49,24.49,0,0,0,4.67-12c0-.45-.59-.47-.73-.1L50.3,60.5l.73.2.48-2.27a.38.38,0,0,0-.73-.2L50,60.75l.72.2.58-2.62c.08-.39-.5-.7-.69-.29l-1.39,3,.68.28,1-2.65-.73-.2-1.08,3,.72.2.75-2.61c.14-.48-.55-.64-.72-.2a12.4,12.4,0,0,1-1.67,3l.69.29,1-2.72-.72-.2a15.63,15.63,0,0,1-1.36,3.21l.65.38,1.18-2.66c.19-.43-.4-.8-.65-.38L47,63l.68.29.48-2.82c.06-.38-.5-.71-.69-.29a14.31,14.31,0,0,0-1,3.14c-.07.38.49.7.68.29l1-2.28L47.54,61a12.64,12.64,0,0,1-1.12,2.69l.69.29a12.46,12.46,0,0,1,1.76-3.42l-.69-.29a33,33,0,0,1-1.58,4.19c-.19.44.41.81.65.38l2.26-3.93a.37.37,0,0,0-.64-.38,21,21,0,0,0-2.52,6.19h.72a8.56,8.56,0,0,1,5.35-9.67L52,56.59a22.38,22.38,0,0,1-2.2,6.83l.68.29,1.12-4.36c.1-.4-.49-.68-.69-.29l-2.79,5.57.68.29,1.11-4.42-.72-.2a31.3,31.3,0,0,1-2.11,6l.7.19L48,63.33c0-.42-.67-.52-.74-.1a28.74,28.74,0,0,0-.3,6.08l.7-.19c-1.14-2.55-2.07-5.57-.64-8.21,1-1.83,2.87-3,4.55-4.16.4-.27,0-.92-.38-.65Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M45.19,39.47l-1.12-1-.37.63a6.84,6.84,0,0,0,3,.35l-.1-.74a3.65,3.65,0,0,0-1.43.61.38.38,0,0,0,.09.68l.39.13-.17-.62-.78.75a.37.37,0,0,0,.36.62l1.47-.51-.36-.63-.92,1.08a.38.38,0,0,0,.27.64,1.72,1.72,0,0,0,1.08-.28l-.51-.51-.53.79A.38.38,0,0,0,46,42l1.26-.48-.36-.63a5.53,5.53,0,0,0-1.2,1.52.38.38,0,0,0,.43.55l1.14-.25-.36-.62c-.6.62-.44,2.07.58,1.38l-.51-.52c-.43.7-.36,1.42.55,1.5l-.33-.57c-.41.69-.39,1.62.61,1.51l-.19-.7c-1.09.84.36,2.12.41,3.17,0,.48.78.49.75,0,0-.14-.56-2.69-.78-2.52.26-.19.23-.74-.19-.7l0-.38a.37.37,0,0,0-.32-.56l.1-.37c.19-.31-.2-.73-.52-.51l.33-.2A.38.38,0,0,0,47,42l-1.14.25.42.55a5.11,5.11,0,0,1,1.08-1.37c.27-.24,0-.76-.37-.62l-1.26.48.43.55.52-.79c.23-.34-.2-.67-.51-.52l-.7.18.26.64.92-1.08c.22-.26,0-.76-.37-.63l-1.47.52.37.63L46,40a.38.38,0,0,0-.17-.63l-.38-.13.09.68a2.28,2.28,0,0,1,1.25-.52c.41-.09.33-.78-.1-.74a6.43,6.43,0,0,1-2.78-.32.37.37,0,0,0-.36.62l1.12,1c.35.33.88-.2.53-.53Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M44.4,40.15l1.43-.86-.46-.59-1.23,1.56c-.25.32.06.82.45.59l1.14-.66-.51-.51A4.11,4.11,0,0,0,44.51,41c-.11.25.21.55.46.46l1.5-.57-.29-.68c-1.44,1-.21,2.89.72,1.52l-.65-.38-.49,1.06a.38.38,0,0,0,.32.56,4.58,4.58,0,0,0,1.11,0l-.27-.64c-.63.59-1.07,2,.29,1.89l-.33-.56c-1.27,1.71,1.74,3.66,1.32,5.56-.1.48.62.68.73.2a3.11,3.11,0,0,0-.21-2.15c-.29-.71-1.81-2.41-1.19-3.23a.38.38,0,0,0-.32-.57l.24-.61a.38.38,0,0,0-.26-.64,4.58,4.58,0,0,1-1.11,0l.33.57.49-1.06a.38.38,0,0,0-.65-.38l.31-.49c.32-.23.14-.85-.29-.69l-1.5.57.46.46.64-1.14c.22-.32-.21-.69-.51-.51l-1.14.65.45.59,1.23-1.56c.25-.31-.06-.83-.45-.59L44,39.5c-.42.25,0,.9.37.65Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M44.66,38.3C46.28,41.6,50,44,50,47.92a.38.38,0,0,0,.75,0c0-4.17-3.73-6.55-5.42-10-.22-.44-.86-.06-.65.38Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M46.35,40.53a5.23,5.23,0,0,1,1.85,2.86.38.38,0,0,0,.73-.2,6,6,0,0,0-2-3.19c-.37-.29-.91.23-.53.53Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M10.84,38.23a30.81,30.81,0,0,1,17.65-4c.48,0,.48-.72,0-.75a31.55,31.55,0,0,0-18,4.09c-.42.23,0,.88.38.64Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M10.08,38.35A25.59,25.59,0,0,1,28.29,33c.48,0,.48-.71,0-.75a26.4,26.4,0,0,0-18.74,5.6c-.38.3.16.83.53.53Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M13.31,35.94a54.48,54.48,0,0,1,14.36-3.68c.48-.06.48-.81,0-.75a55.17,55.17,0,0,0-14.56,3.71c-.44.17-.25.9.2.72Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M14.55,35.3a69,69,0,0,1,14.38-1.95.38.38,0,0,0,0-.75,70.27,70.27,0,0,0-14.58,2,.38.38,0,0,0,.2.73Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M26.89,59.4l-.39,1c-.16.41.47.62.69.29A7.49,7.49,0,0,1,28.76,59l-.59-.46-1.34,1.94c-.21.3.21.74.51.52L29,59.67l-.45-.59-1.13,1.33a.38.38,0,0,0,.54.53l1.41-1.13-.59-.45a7.81,7.81,0,0,0-.63,1.69.38.38,0,0,0,.63.37,5.32,5.32,0,0,0,1.08-1.48l-.68-.29L28.73,61c-.13.39.36.57.63.36a3.78,3.78,0,0,0,1-1.15l-.65-.38a8.74,8.74,0,0,0-.57,1.55.38.38,0,0,0,.63.36,5.46,5.46,0,0,0,.88-1L30,60.39l-.59,1.19A.38.38,0,0,0,30,62l.74-.66L30.11,61l-.49,1.17c-.15.38.38.58.63.36l.86-.74-.59-.45-.3.71c-.17.37.26.77.58.45l.52-.49-.63-.37-.26,1.21a.38.38,0,0,0,.62.37l.63-.62-.63-.36-.39,1.16a.38.38,0,0,0,.55.42,2.16,2.16,0,0,0,.65-.59l-.62-.36L30.93,64c-.08.3.27.63.55.43l.55-.4-.57-.32v1.34a.38.38,0,0,0,.75,0V63.73a.38.38,0,0,0-.56-.33l-.55.4.55.42L32,63.08c.09-.34-.38-.66-.63-.37l-.5.47.55.43.4-1.17c.12-.36-.38-.61-.63-.36l-.63.62.63.36.27-1.21a.38.38,0,0,0-.63-.36l-.52.49.59.46.31-.71a.38.38,0,0,0-.59-.46l-.86.74.63.37.48-1.17c.16-.37-.38-.58-.63-.36l-.74.66.59.45.59-1.19a.38.38,0,0,0-.65-.38,3.16,3.16,0,0,1-.76.83l.63.37a6.42,6.42,0,0,1,.49-1.37.38.38,0,0,0-.65-.38,3.34,3.34,0,0,1-.87,1l.62.37.46-1.36a.38.38,0,0,0-.69-.28,4.75,4.75,0,0,1-1,1.32l.62.36a7.92,7.92,0,0,1,.55-1.52.37.37,0,0,0-.58-.45l-1.42,1.13.54.53,1.12-1.33c.25-.3-.09-.87-.46-.59L27,60.3l.52.51,1.34-1.94c.26-.37-.28-.7-.59-.45a8.06,8.06,0,0,0-1.69,1.9l.68.29.4-1c.17-.45-.55-.65-.73-.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M27,54.1c-2.82,1.12-4,3.61-4.76,6.4a.38.38,0,0,0,.69.28,13.11,13.11,0,0,1,3.91-4.85l-.46-.59L24.81,57.1c-.32.36.18.88.53.53a13.9,13.9,0,0,1,2.34-1.85l-.45-.58a14.54,14.54,0,0,0-1.5,1.44.37.37,0,0,0,.53.53l1.15-1-.53-.53a9.21,9.21,0,0,0-2.65,4.14c-.15.46.56.64.72.2a5.73,5.73,0,0,1,4-3.68l-.42-.55-.23.46c-.12.26.09.69.43.55l.42-.18-.42-.55-.75,1c-.26.36.29.72.59.45l.73-.63-.59-.46-.62.81c-.24.3.21.71.51.52l.85-.56L29,56.71l-.23.52c-.13.32.16.73.52.51l.54-.33-.51-.51-.34.54c-.15.25.12.68.43.55l.51-.21-.43-.55-.28.43c-.19.28.12.62.43.55l.49-.12-.46-.46-.08.32a.38.38,0,0,0,.46.46l.42-.06L30,57.8l-.17.38a.38.38,0,0,0,.52.51l.35-.17L30.22,58l-.17.25c-.21.3.13.59.42.55l.36-.06-.46-.46-.08.23c-.11.29.2.51.46.46l.21,0-.42-.55-.16.26a.38.38,0,0,0,.42.55l.46-.15-.46-.47,0,.25c0,.26.16.57.46.46a6.24,6.24,0,0,0,2.71-1.81c.22-.25,0-.78-.37-.63l-1.62.68.43.55.58-.76c.28-.3-.09-.83-.46-.59l-1.8,1.14.38.65,1.22-.92c.37-.29,0-.91-.38-.65l-1.18.71.46.59.44-.43c.3-.29-.09-.83-.45-.59l-.52.36.52.51.33-.52a.37.37,0,0,0-.51-.51l-.62.37.51.51.31-.43c.23-.32-.2-.69-.51-.51l-.37.21.55.42.11-.32c.09-.25-.2-.57-.46-.46l-.1,0a.4.4,0,0,0-.36-.28l-.2-.16c0-.21-.29-.29-.46-.26l-.6.12.47.36V56.2a.38.38,0,0,0-.75,0v.41A.38.38,0,0,0,29,57a1.16,1.16,0,0,1,.83.52.37.37,0,0,0,.46.26l.43-.18-.46-.46-.11.32a.38.38,0,0,0,.55.43l.37-.22-.52-.51-.3.43c-.23.32.2.7.51.52l.62-.37-.52-.52-.33.53c-.2.3.2.72.51.51l.52-.36-.46-.59-.44.43a.37.37,0,0,0,.45.59l1.18-.71-.38-.65-1.22.92c-.37.29,0,.92.38.65l1.8-1.14-.45-.59a3.46,3.46,0,0,0-.7.91c-.16.26.11.68.42.55l1.62-.67-.36-.63A5.6,5.6,0,0,1,31,58.56l.46.46,0-.25a.38.38,0,0,0-.46-.46l-.45.16L31,59l.15-.26a.38.38,0,0,0-.42-.55l-.21,0,.46.46.08-.23c.12-.3-.2-.49-.46-.46l-.36,0,.43.55.16-.24c.23-.33-.2-.66-.51-.51L30,58l.51.51.17-.38a.39.39,0,0,0-.43-.55l-.42.07.46.46.08-.32a.38.38,0,0,0-.46-.46l-.49.12.42.55.28-.43c.17-.26-.12-.68-.42-.56l-.51.21.42.55.34-.53a.38.38,0,0,0-.52-.51l-.54.33.51.51.22-.52c.14-.31-.16-.75-.51-.52l-.85.56.51.51.62-.81c.28-.35-.28-.72-.58-.45l-.73.63.59.46.75-1c.18-.25-.13-.68-.42-.55l-.43.18.42.55.23-.46a.38.38,0,0,0-.43-.55,6.51,6.51,0,0,0-4.56,4.2L25,60a8.42,8.42,0,0,1,2.46-3.81c.36-.33-.17-.84-.53-.53l-1.15,1,.53.53a14.54,14.54,0,0,1,1.5-1.44c.33-.28-.1-.82-.45-.59a14,14,0,0,0-2.5,2l.53.53,1.58-1.76c.27-.3-.08-.84-.45-.59a13.92,13.92,0,0,0-4.18,5.13l.69.29c.69-2.48,1.66-4.85,4.23-5.88.44-.18.25-.9-.2-.72Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M43.3,68.42a6.31,6.31,0,0,0,1.59-3.55.15.15,0,0,0-.26-.11,7,7,0,0,1-1.81,1.4c-.17.09,0,.35.15.26A7.12,7.12,0,0,0,44.84,65l-.25-.1a5.92,5.92,0,0,1-1.5,3.33c-.13.15.08.36.21.22Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M37,68.21a3.66,3.66,0,0,0,1.3-2.75.14.14,0,0,0-.22-.13l-2,1.39c-.16.11,0,.37.15.26l2-1.39L38,65.46A3.38,3.38,0,0,1,36.78,68c-.15.12.07.33.21.21Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M39.18,67.49h-.11l0,.3.43-.11a.15.15,0,0,0-.08-.29l-.43.11a.15.15,0,0,0,0,.29h.11a.15.15,0,0,0,0-.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M39.4,67.39h-.13a.15.15,0,1,0,0,.3h.13a.15.15,0,0,0,0-.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M39.4,67.69a.15.15,0,0,0,0-.3.15.15,0,0,0,0,.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M39.41,67.4l-.27,0c-.19,0-.11.32.08.28l.27,0c.19,0,.11-.32-.08-.29Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M39.55,67.41l-.35.12c-.18.06-.1.35.08.29l.35-.12c.18-.06.1-.35-.08-.29Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M39.39,66.8a2.21,2.21,0,0,1,.65-.33c.18-.06.1-.35-.08-.29a2.7,2.7,0,0,0-.72.36c-.16.11,0,.37.15.26Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M39.47,66.81a2.65,2.65,0,0,1,.52-.29c.18-.07.1-.36-.08-.29a3.37,3.37,0,0,0-.59.32c-.15.12,0,.38.15.26Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M39.36,66.84l.57-.32a.15.15,0,0,0-.15-.26l-.57.32c-.17.1,0,.36.15.26Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M39.34,67a2.23,2.23,0,0,1,.6-.46.15.15,0,0,0-.15-.26,2.71,2.71,0,0,0-.66.51c-.13.14.08.36.21.21Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M39.3,66.93a2,2,0,0,1,1-.49c.19,0,.11-.32-.08-.29a2.17,2.17,0,0,0-1.14.57c-.14.13.07.34.21.21Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M40.46,66.48A3.55,3.55,0,0,1,42,67a.15.15,0,0,0,.15-.26,4,4,0,0,0-1.73-.55c-.2,0-.2.29,0,.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M40.39,66.62a1.83,1.83,0,0,1,1.78.87.15.15,0,0,0,.26-.15,2.13,2.13,0,0,0-2-1c-.19,0-.19.32,0,.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M40.82,66.68a1.49,1.49,0,0,1,1.44.77.15.15,0,0,0,.26-.15,1.8,1.8,0,0,0-1.7-.92c-.19,0-.19.31,0,.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M42.93,66.4a13.08,13.08,0,0,0,1.46-.83l-.16-.26-1.6,1.17c-.16.12,0,.38.15.26l1.61-1.17c.15-.11,0-.37-.16-.26a12.11,12.11,0,0,1-1.45.83c-.17.08,0,.34.15.26Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M43.71,65.71a11.54,11.54,0,0,0-1.26,1c-.14.12.07.33.22.21a9.53,9.53,0,0,1,1.19-.9c.16-.1,0-.36-.15-.26Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M43.38,65.92l-.88.89c-.13.14.07.33.22.21l.8-.63-.21-.21-.68.73a.15.15,0,0,0,.21.21l.55-.49-.21-.21-.46.57c-.1.14,0,.32.18.24a1.19,1.19,0,0,0,.39-.27l-.22-.21-.28.34c-.08.09,0,.27.1.26a.45.45,0,0,0,.29-.1L43,67.08l-.06.13c-.11.15.15.3.26.15a.31.31,0,0,0,.09-.2c0-.11-.1-.24-.22-.16l-.14,0,.11.25.29-.34c.12-.15-.08-.35-.22-.21a.8.8,0,0,1-.32.22l.18.24.46-.58a.15.15,0,0,0-.21-.21l-.55.49.21.21.68-.73a.15.15,0,0,0-.21-.21l-.81.63.22.21.87-.89c.14-.14-.08-.35-.21-.21Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M43.69,65.6a12.11,12.11,0,0,1-1.46.89c-.17.09,0,.35.15.26a11,11,0,0,0,1.46-.9c.15-.11,0-.37-.15-.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M43.35,65.78l-1.15.66c-.16.1,0,.36.15.26L43.5,66c.17-.09,0-.35-.15-.26Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M43.24,65.83a5.66,5.66,0,0,1-1,.55c-.17.08,0,.33.15.26a5.66,5.66,0,0,0,1-.55c.15-.11,0-.37-.15-.26Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M43.21,66l-1,.46c-.18.08,0,.34.15.26l1-.46c.18-.08,0-.34-.15-.26Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M43.35,65.84l-1.18.69c-.17.09,0,.35.15.25l1.18-.68a.15.15,0,0,0-.15-.26Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M43.4,65.75l-.85.52c-.16.1,0,.36.15.26l.85-.53c.16-.1,0-.36-.15-.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M39,71.5a.67.67,0,0,1,.36.21.15.15,0,0,0,.25-.06.5.5,0,0,0,0-.36c0-.19-.32-.11-.29.08l0,.2.25-.07a1.1,1.1,0,0,0-.49-.28.15.15,0,1,0-.08.28Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M39.59,71.68a.52.52,0,0,0,.54-.75l-.28.12c.2.37.81.5.71-.06l-.25.15a.37.37,0,1,0,.47-.55l-.15.25c.22.15.76.43,1,.15a.25.25,0,0,0-.15-.42l0,.29a.94.94,0,0,0,1-.65c.07-.18-.22-.25-.29-.08a.65.65,0,0,1-.71.43c-.17,0-.2.26,0,.3a2.37,2.37,0,0,1-.61-.27c-.16-.11-.31.15-.15.25l-.1.08c-.11-.12-.28,0-.25.15l-.17-.18c-.07-.14-.34,0-.27.12l-.25.37c-.19,0-.19.29,0,.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M35.32,71.41l.06,0-.22-.17-.1.63c0,.14.13.26.25.14a1.49,1.49,0,0,0,.36-.5l-.28-.08v.45a.15.15,0,0,0,.28.08c.12-.22.11-.21.22,0a.16.16,0,0,0,.21.06l.06,0c.17-.09,0-.35-.15-.26l-.06,0,.2.05a1.76,1.76,0,0,0-.24-.42.16.16,0,0,0-.15,0c-.19,0-.26.27-.35.44l.28.07V71.4a.15.15,0,0,0-.28-.07,1.52,1.52,0,0,1-.31.44l.25.15.1-.63c0-.12-.1-.25-.22-.17l-.06,0c-.16.11,0,.37.15.26Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M36,71.44a1.06,1.06,0,0,0,.43.53c.16.11.31-.15.15-.26l-.29-.35c-.07-.18-.36-.1-.29.08Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M36.51,71.51a.46.46,0,0,0,.45.37c.19,0,.19-.27,0-.3l-.17-.15a.15.15,0,1,0-.28.08Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M36.91,71.6s.53.2.64.2.2-.31,0-.3-.46-.4-.79-.16c-.15.11,0,.37.15.26Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M37.59,71.47a1.11,1.11,0,0,0,.29.32c.16.11.31-.15.16-.26l-.19-.21c-.1-.16-.36,0-.26.15Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M38,71.37a.5.5,0,0,0,.5.4c.19,0,.19-.29,0-.3l-.21-.18c0-.19-.33-.11-.29.08Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M38.57,71.39a.37.37,0,0,0,.43.33c.19,0,.19-.31,0-.3l-.14-.11c0-.19-.32-.11-.29.08Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M39.1,71.4a.55.55,0,0,0,.25.25.15.15,0,0,0,.15-.26l-.15-.14c-.1-.16-.37,0-.25.15Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M39.74,71.21l.07.2a.15.15,0,0,0,.29-.08l-.07-.2c-.06-.18-.35-.11-.29.08Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M35.2,71.43a.15.15,0,0,0,0-.3.15.15,0,0,0,0,.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M35.28,71.15a1.13,1.13,0,0,0-1.27.06c-.15.11,0,.37.15.26a.86.86,0,0,1,1-.07c.17.1.32-.16.15-.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M34.45,70.91a1.85,1.85,0,0,0-.58.25c-.16.1,0,.36.15.26a1.52,1.52,0,0,1,.51-.22.15.15,0,0,0-.08-.29Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M34.27,70.77l-.66.14a.15.15,0,0,0,.08.29l.66-.14c.19,0,.11-.33-.08-.29Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M33.81,70.57a1.11,1.11,0,0,0-.49.17c-.16.1,0,.36.15.26a.73.73,0,0,1,.42-.14c.19,0,.11-.32-.08-.29Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M33.63,70.42a1.44,1.44,0,0,0-.67.19c-.17.09,0,.35.15.26a.88.88,0,0,1,.52-.15c.19,0,.19-.31,0-.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M33.54,70a3,3,0,0,0-.92.28c-.18.08,0,.34.15.26a2.78,2.78,0,0,1,.85-.25c.19,0,.11-.32-.08-.29Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M33.24,69.81a.76.76,0,0,0-.61.18c-.15.12.06.33.21.21l.4-.09c.19,0,.19-.28,0-.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M33,69.58a2.35,2.35,0,0,0-.59,0c-.18,0-.1.33.08.29a1.26,1.26,0,0,1,.51,0c.19,0,.19-.29,0-.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M32.8,69.06a.92.92,0,0,0-.55.17c-.16.12,0,.38.15.26a.53.53,0,0,1,.4-.13c.2,0,.2-.31,0-.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M32.64,68.73,32,68.67c-.19,0-.19.28,0,.3l.64.06c.2,0,.19-.28,0-.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M32.41,68.29a1,1,0,0,0-.6.09c-.17.09,0,.35.15.26l.37-.06c.19,0,.27-.27.08-.29Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M32.12,68l-.37,0c-.19,0-.19.31,0,.3l.37,0c.19,0,.19-.31,0-.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M32.1,68a.41.41,0,0,0-.6,0c-.15.13.07.35.21.22h.18c.15.12.36-.09.21-.21Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M32.19,68.47a.64.64,0,0,0-.56.33.15.15,0,0,0,.26.15l.3-.18c.19,0,.19-.31,0-.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M32.23,68.82l.05,0-.07-.17c0,.06-.18.12-.22.15a.58.58,0,0,0-.14.33c0,.18.26.27.29.07s.32-.23.36-.47a.17.17,0,0,0-.07-.17l0,0c-.15-.11-.3.15-.15.26Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M32.86,69.14a.49.49,0,0,0-.53.64c0,.19.32.11.29-.08l.24-.26c.2,0,.19-.29,0-.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M33.05,69.61a.93.93,0,0,0-.52.78c0,.19.29.19.3,0a.57.57,0,0,1,.37-.52c.17-.09,0-.35-.15-.26Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M33.27,70.07a.85.85,0,0,0-.18.67c0,.19.32.19.3,0a.74.74,0,0,1,.14-.52c.11-.16-.15-.31-.26-.15Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M33.71,70.44a2.75,2.75,0,0,0,0,.86c0,.19.32.11.29-.08a2.34,2.34,0,0,1,0-.7c0-.18-.26-.27-.29-.08Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M34.27,70.84a1.25,1.25,0,0,0,.12.87c.09.18.35,0,.26-.15a.8.8,0,0,1-.09-.64c0-.19-.25-.27-.29-.08Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M34.71,71.17a1.15,1.15,0,0,0,.14.63c.09.17.35,0,.26-.15a.68.68,0,0,1-.1-.48c0-.19-.28-.19-.3,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M35.24,71.1a.86.86,0,0,0,.42.84c.16.11.31-.15.15-.26a.55.55,0,0,1-.27-.58c0-.19-.28-.19-.3,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M35.83,71.31a1.39,1.39,0,0,0,.52.53c.17.09.32-.17.15-.26a1,1,0,0,1-.41-.42c-.09-.17-.35,0-.26.15Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M36.54,71.36a.87.87,0,0,0,.47.37c.18.06.26-.23.08-.29l-.29-.23c-.11-.16-.37,0-.26.15Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M37.16,71.35a.48.48,0,0,0,.46.34c.2,0,.2-.29,0-.3l-.17-.12c-.07-.18-.36-.1-.29.08Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M37.89,71.31a.5.5,0,0,0,.6.28c.19,0,.11-.33-.08-.29l-.26-.14c-.09-.17-.35,0-.26.15Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M38.68,71.36a.65.65,0,0,0,.3.29c.18.08.33-.18.16-.26l-.2-.18c-.09-.17-.35,0-.26.15Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M39.46,71.12a.35.35,0,0,0,.56.31c.16-.1,0-.36-.15-.26l-.11,0c0-.19-.31-.19-.3,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M40.15,71.18a.48.48,0,0,0,.46.09.15.15,0,0,0-.08-.29l-.23,0c-.16-.12-.31.14-.15.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M40.73,70.9c0,.22.2.35.39.21s0-.36-.15-.26l.06.05c0-.19-.31-.19-.3,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M41.08,71c.13-.09.39.15.55.14a.36.36,0,0,0,.26-.14c.13-.15-.08-.36-.21-.22s-.37-.11-.48-.12a.38.38,0,0,0-.27.08c-.15.11,0,.37.15.26Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M41.88,70.54c-.05.27.07.45.36.45s.19-.31,0-.3l-.07-.07c0-.19-.26-.27-.29-.08Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M42.07,70.66l.46-.15a.15.15,0,0,0-.08-.29l-.46.15a.15.15,0,0,0,.08.29Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M42,70.24a2,2,0,0,0,.54.05c.2,0,.2-.31,0-.3a1.2,1.2,0,0,1-.46,0c-.19,0-.27.25-.08.29Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M41.63,70.26a.81.81,0,0,0,.25.35c.15.13.36-.08.21-.21a.56.56,0,0,1-.21-.29c-.07-.18-.33,0-.25.15Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M41.32,70.68l.3.15c.17.09.32-.17.15-.26l-.3-.15c-.17-.09-.32.17-.15.26Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M41.24,70.51h-.06a.17.17,0,0,0-.11.15c0,.36.47.29.69.26s.19-.32,0-.3c0,0-.39,0-.39,0l-.11.14h.06a.15.15,0,0,0-.08-.29Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M41.39,70.7l.64-.08c.19,0,.11-.32-.08-.29l-.64.08c-.19,0-.11.32.08.29Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M41.85,70.49a1.17,1.17,0,0,0,.58-.12c.17-.09,0-.35-.15-.26a.66.66,0,0,1-.43.08c-.19,0-.19.29,0,.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M42.08,70.13a1,1,0,0,0,.46-.13c.17-.09,0-.35-.15-.26l-.31.09c-.19,0-.2.31,0,.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M42.2,70a5,5,0,0,1,.76-.21c.19,0,.11-.32-.07-.29a4.85,4.85,0,0,0-.77.21c-.18.07-.1.36.08.29Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M42.49,69.69a1.39,1.39,0,0,0,.6-.14c.18-.08,0-.34-.15-.26a.79.79,0,0,1-.45.1c-.19,0-.19.31,0,.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M43.23,69.39l.05-.12c.12-.15-.09-.37-.21-.22a.48.48,0,0,0-.14.34c0,.19.29.19.3,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M32.89,59.62a.31.31,0,0,0-.22-.09c-.2,0-.2.29,0,.3h0c.15.12.37-.09.22-.21Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M32.78,59.88a.15.15,0,0,0,0-.3.15.15,0,0,0,0,.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M32.75,59.5l-.2-.18a.16.16,0,0,0-.26.11c-.17,1.29,1.13,2.57,1.88,3.51.09.12.29,0,.25-.14a12.69,12.69,0,0,0-1.26-2.69.15.15,0,0,0-.27.12l.41,1.49a.15.15,0,0,0,.29-.08l-.19-.74c0-.19-.32-.11-.29.08a1.84,1.84,0,0,0,.29.82l.26-.16c-.33-.58-1.1-1.25-1.08-1.91l-.26.1.5.52c.12.14.29,0,.23-.18a.93.93,0,0,0-.26-.42c-.1-.12-.29,0-.25.15a1.89,1.89,0,0,0,.52.91c.11.12.33,0,.23-.18L32.84,60a.15.15,0,0,0-.28.07,2.53,2.53,0,0,0,.11.91l.29-.08a1.05,1.05,0,0,1,.61-1.52l-.07-.28-.58.43c-.15.11,0,.37.16.26a5.57,5.57,0,0,1,.92-.52L33.82,59l-1,.84c-.13.11,0,.33.19.24a4.9,4.9,0,0,0,.94-.82l-.21-.21-.8,1c-.12.15.08.36.21.21l.83-.95-.24-.18-.64,1.09c-.1.17.15.3.26.15l.67-.9c.11-.15-.15-.3-.26-.15a6,6,0,0,0-.83,1.5c-.06.16.2.27.28.12l.75-1.39a.15.15,0,0,0-.26-.15,2.76,2.76,0,0,0,.11,3,.15.15,0,0,0,.28-.08l-.11-2.59a.15.15,0,0,0-.29,0,3.87,3.87,0,0,0,1.17,3.89l.15-.25-.14-.06c-.12-.05-.24.12-.17.22a5.56,5.56,0,0,0,2.37,2c.17.08.32-.18.15-.26a5.27,5.27,0,0,1-2.26-1.92l-.17.22.14.06c.15.06.23-.15.14-.25a3.57,3.57,0,0,1-1.09-3.6l-.3,0,.11,2.59.28-.08a2.45,2.45,0,0,1-.11-2.73l-.26-.15-.75,1.39.27.11a5.54,5.54,0,0,1,.8-1.43l-.26-.15-.67.9.26.15L34,59.28c.09-.14-.12-.31-.23-.18l-.83.95.21.21.8-1c.12-.15-.08-.36-.21-.21a3.09,3.09,0,0,1-.88.77l.18.23,1-.84c.15-.11,0-.3-.18-.23a6.1,6.1,0,0,0-.93.52l.16.26.57-.43c.11-.09.09-.28-.08-.28-1.09,0-1.09,1.08-.9,1.9,0,.19.33.11.29-.08l-.1-.83-.28.08.46.65.23-.18-.44-.78-.25.15.21.35.24-.18-.5-.52a.15.15,0,0,0-.25.11c0,.94.68,1.29,1.12,2.07.09.17.34,0,.26-.16l-.26-.74-.29.08.19.74.29-.08-.41-1.49-.28.11a12.53,12.53,0,0,1,1.23,2.62l.25-.15c-.64-.8-1.94-2.17-1.79-3.3l-.25.11.2.18c.14.13.35-.09.21-.22Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M37.34,65.56a6,6,0,0,1,3.89-.2.15.15,0,0,0,.08-.29,6.18,6.18,0,0,0-4.05.2c-.18.07-.1.36.08.29Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/COIN.ff4cad0434f05809694a641d6ee12672.svg";
export { ForwardRef as ReactComponent };